export var languages = {
    'es': {
        'typePassenger': {
            'adult': 'adulto',
            'child': 'niño',
            'handicapped': 'discapacitado',
            'infant': 'bebe',
            'military': 'militar',
            'pensioner': 'pensionista',
            'senior': 'mayor',
            'student': 'estudiante',
            'resident': 'residente'
        },
        '0-introduccion': '0 - Introducción',
        '1-crearnegocio': '1 - Crear negocio',
        '1-introduccion': '01. Introducción',
        '2-crearUsuario': '2 - Crear usuario',
        '2-negocios': '02. Negocio',
        '3-modificarUsuario': '3 - Modificar usuario',
        '3-usuarios': '03. Usuario',
        '4-categoriasPasajeroHorarios': '04. Categoría pasajero, horarios',
        '4-crearCategoriaPasajero': '4 - Crear categoría de pasajero',
        '5-impuestoExtrasMonedas': '05. Impuestos, extras, monedas',
        '5-Linea de operacion': '5 - Línea de operación',
        '6-lineaOperacion': '06. Línea de operación',
        '6-servicio ida y vuelta': '6 - Servicio ida y vuelta',
        '7-ServicioHopONHopoff': '7 - Servicio HopONHopOFF',
        '7-servicios': '07. Servicios',
        '8-crearHorarios': '8 - Crear horarios',
        '9-servicioConHorario': '9 - Servicio con horario',
        '10-listadoTickets': '10 - Listado tickets',
        '11-crearPaquete': '11 - Crear paquete',
        '12-familiasArticulos': '12 - Familias de artículo',
        'availableVersionIn': 'hay disponible una versión más reciente, pulse en',
        'currentVersion': 'versión actual',
        'latestVersion': 'versión disponible',
        'versionCheck': 'versión del programa',
        'noContact': 'no tiene datos de contacto, no es posible continuar',
        'isUpDate': 'está actualizado',
        'acount': 'mi cuenta',
        'action': 'acción',
        'actives': 'activos',
        'active': 'activo',
        'activo': 'activo',
        'add': 'añadir',
        'additional': 'adicional',
        'addRow': 'añadir fila',
        'addSeats': 'añadir asientos',
        'address': 'dirección',
        'aditional': 'información adicional',
        'additionalInformation': 'información adicional',
        'additionalNote': 'nota adicional',
        'aditionalInfo': 'Información adicional del servicio que saldrá al final del ticket',
        'additionalrequiredinformation': 'información adicional requerida',
        'additionalrequiredinformationTooltip': 'se requiere que el cliente añada información adicional antes de pagar, como puede ser lugar de recogida, número de vuelo, ...',
        'administrator': 'administrador',
        'adult': 'adulto',
        'afiliate': 'afiliado',
        'afiliateName': 'afiliado',
        'afiliates': 'afiliados',
        'alphabeticCode': 'código alfabético',
        'all': 'todos',
        'allAfiliates': 'afiliados',
        'allBusiness': 'todos los negocios',
        'allDiscounts': 'código descuentos',
        'allocation': 'reparto',
        'allTickets': 'todos los tickets',
        'alpha_dash_space': 'El campo :attribute solo debe contener letras, números, guiones y espacios (espacios no al final).',
        'amount_paid': 'importe pagado',
        'amount_paid_boxoffice': 'importe cobrado en taquilla',
        'aPartirValidacion': 'a partir de la primera validación',
        'apiToken': 'private api token',
        'appDevices': 'dispositivos app',
        'appliedCorrectly': 'netos aplicados correctamente',
        'appliedError': 'error aplicando netos',
        'applyNet': 'aplicar neto a todos los servicios compartidos',
        'applyCommission': 'se va a aplicar la comisión, se sobreescribirán los valores actuales',
        'appName': 'backoffice web',
        'areaconfig': 'configuración zona',
        'article': 'artículo',
        'articleTickets': 'tickets de artículo',
        'articles': 'artículos',
        'as': 'como',
        'askAdditionalInformation': 'solicite cualquier información adicional',
        'atraccion': 'atraccion',
        'autobus': 'autobus',
        'available': 'disponible',
        'avion': 'avion',
        'back': 'atrás',
        'barco': 'barco',
        'barcode': 'código de barras',
        'beCollaborator': 'ser colaborador',
        'bicicleta': 'bicicleta',
        'block': 'bloqueado',
        'bookingFee': 'booking fee',
        'blocked': 'bloqueado',
        'branch': 'delegación',
        'brand': 'marca',
        'branches': 'delegaciones',
        'buceo': 'buceo',
        'bus': 'bus',
        'business': 'negocio',
        'businessName': 'nombre fiscal',
        'businessunit': 'negocio',
        'businessUnit': 'negocio',
        'businessUnitName': 'negocio',
        'businessunits': 'negocios',
        'businessUnits': 'negocios',
        'busParada': 'busParada',
        'busTuristico': 'busTuristico',
        'byDate': 'por fecha',
        'byDays': 'por días',
        'byGroup': 'grupo',
        'byHours': 'por horas',
        'byMonth': 'por mes',
        'byPassenger': 'pasajero',
        'bySaleDate': 'por fecha de venta',
        'byUseDate': 'por fecha de uso',
        'cabeceraTicket': 'cabecera de ticket',
        'calculadora_precios_sin_iva': 'calculadora de precios sin tasas',
        'calendar': 'calendario',
        'calendarAvailable': 'disponibilidad en calendario',
        'calendarMonth': 'calendario mes',
        'cancel': 'cancelar',
        'canceled': 'cancelado',
        'canceledNoModified': 'ticket cancelado, no se puede modificar',
        'canceleds': 'cancelados',
        'canceledTickets': 'tickets cancelados',
        'capacity': 'capacidad',
        'card': 'tarjeta',
        'cardAmount': 'tarjeta',
        'carded': 'total en tarjeta',
        'cash': 'efectivo',
        'cashAmount': 'efectivo',
        'cashDesk': 'caja',
        'cashDeskClosures': 'cierres de caja',
        'cashDeskOpen': 'la caja ya está abierta',
        'cashed': 'total en efectivo',
        'categoriaPasajero': 'categoria de pasajero',
        'category': 'categoría',
        'categories': 'categorías',
        'changeDatebook': 'cambiar fecha de uso',
        'checkins': 'personas',
        'city': 'ciudad',
        'client': 'cliente',
        'close': 'cierre',
        'code': 'código',
        'codeDiscount': 'código descuento',
        'collaborator': 'colaborador',
        'collaboratorCode': 'código colaborador',
        'collaboratorEmail': 'email colaborador',
        'collaboratorName': 'nombre colaborador',
        'collaboratorStretchValues': 'servicios en colaboración',
        'collaboratorService': 'venta a colaboradores',
        'collaboratorTin': 'CIF colaborador',
        'collaborators': 'colaboradores',
        'collaboratorTickets': 'venta a colaboradores',
        'collaboratorpackets': 'paquetes en colaboración',
        'collaboratorPacket': 'paquete en colaboración',
        'collaboratorspackets': 'paquetes en colaboración',
        'collaboratorStretch': 'servicio en colaboración',
        'collaboratortretches': 'servicios en colaboración',
        'commission': 'comisión',
        'collaboratorstretches': 'servicios en colaboración',
        'concepto': 'concepto',
        'confirmDelete': '¿Confirmar eliminar?',
        'confirmDisable': '¿Confirmar deshabilitar?',
        'confirmEnable': '¿Confirmar habilitar?',
        'contact': 'contacto',
        'contactEmail': 'email de contacto',
        'contactAdditional': 'información adicional',
        'contactName': 'persona de contacto',
        'contactPhone': 'teléfono de contacto',
        'copiedToClipboard': 'copiado a portapapeles',
        'copyToClipboard': 'copiar a portapapeles',
        'cost': 'coste',
        'create': 'crear',
        'credit': 'crédito',
        'creditCanceled': 'crédito cancelado',
        'credited': 'total a crédito',
        'currency': 'nombre moneda',
        'custom': 'personalizado',
        'customed': 'personalizado',
        'customized': 'personalizado',
        'customers': 'clientes',
        'date': 'fecha',
        'dashboard': 'dashboard',
        'dashboardticket': 'dashboard ticket',
        'dataWeb': 'datos web',
        'datebook': 'fecha uso',
        'dateBook': 'fecha de uso',
        'dateClose': 'fecha cierre',
        'datecheck': 'emitido',
        'dateCheck': 'emitido',
        'dateEvent': 'fecha evento',
        'dateMaxToReserve': 'fecha máxima para reservar',
        'dateOpen': 'fecha apertura',
        'dateRefund': 'fecha cancelación',
        'dateSI': 'fecha factura s.',
        'dateValited': 'fecha validación',
        'daterefund': 'cancelado',
        'datevalited': 'validado',
        'day': 'día',
        'delayTime': 'tiempo de demora',
        'delete': 'eliminar',
        'departureTime': 'Horarios de salida',
        'description': 'descripción',
        'descriptionCollabortorModule': 'módulo que permite la venta en colaboración de experiencias-servicios de otros proveedores',
        'descriptionAppModule': 'módulo para la venta al cliente final con intervención de personal de la empresa con un dispositivo físico móvil android a tavés de la app',
        'descriptionEcommerceModule': 'módulo para la venta al cliente final sin intervención del personal de la empresa',
        'descriptionVirtualModule': 'módulo para la venta al cliente final con intervención de personal de la empresa a través de un dispositivo virtual',
        'desde': 'desde',
        'destination': 'destino',
        'devices': 'dispositivos',
        'disable': 'deshabilitar',
        'disableAll': 'deshabilitar todo',
        'disabled': 'deshabilitado',
        'disableMonth': 'deshabilitar mes',
        'disabled_at': 'deshabilitado en',
        'disableWeb': 'deshabilitar en web',
        'disableWebTooltip': 'seleccione para no permitir vender en web',
        'disableVirtual': 'deshabilitar en virtual',
        'disableVirtualTooltip': 'seleccione para no permitir vender en virtual',
        'disableTerminal': 'deshabilitar en terminal android',
        'disableTerminalTooltip': 'seleccione para no permitir vender en terminal android',
        'discount': 'descuento',
        'discountcodes': 'códigos de descuento',
        'discountreasons': 'razón descuento',
        'discountTickets': 'tickets descuento',
        'download': 'descargar',
        'dropOffLocations': 'lugar de destino',
        'due': 'aplazado',
        'duplicate': 'duplicar',
        'edit': 'editar',
        'email': 'email',
        'emails': 'emails',
        'emailsToSend': 'emails a enviar notificación de reserva',
        'enable': 'habilitar',
        'enableAll': 'habilitar todo',
        'enabled': 'habilitado',
        'enableMonth': 'habilitar mes',
        'endHour': 'hora de finalización',
        'error_array_emails_comma': 'error en lista de emails (introduzca separados por comas y sin espacios en blanco)',
        'event': 'evento',
        'excursion': 'excursion',
        'expiredLicense': 'licencia caducada',
        'expire': 'termina',
        'expire_at': 'termina',
        'families': 'familias',
        'extras': 'extras',
        'family': 'familia',
        'fix': 'fijo',
        'flightInfo': 'información del vuelo si corresponde o cualquier otra nota',
        'following': 'siguiente',
        'footer': 'pie',
        'from': 'desde',
        'fromRange': 'desde',
        'funcion': 'funcion',
        'funicular': 'funicular',
        'handicapped': 'discapacitado',
        'generalSales': 'ventas generales',
        'hasta': 'hasta',
        'headboards': 'cabeceras de ticket',
        'header': 'cabecera',
        'helicopero': 'helicopero',
        'help': 'ayuda',
        'hoponHopoff': 'HopON-HopOFF',
        'hopOnOff': 'hopOnOff',
        'hora': 'hora',
        'horasIda': 'horarios de salida',
        'horasVuelta': 'horario de vuelta',
        'hours': 'horas',
        'id': 'ID',
        'ida': 'Ida',
        'idavuelta': 'idavuelta',
        'idaVuelta': 'Ida Y Vuelta',
        'in': 'entrada',
        'info': 'información',
        'infoDataweb': 'descripción',
        'infant': 'bebe',
        'initHour': 'hora de inicio',
        'image': 'imagen',
        'imageProperties': 'imagen en formato jpg con un mínimo de 600x600 px',
        'imagesDataweb': 'imágenes',
        'informationWeb': 'información web',
        'invoice': 'factura',
        'invoiceSimple': 'factura simplificada',
        'lancha': 'lancha',
        'lastname': 'apellidos',
        'left': 'izquierda',
        'license': 'licencia',
        'licenses': 'licencias',
        'list': 'listado',
        'listMonth': 'listado mes',
        'limitUse': 'límite de usos',
        'logIn': 'iniciar sesión',
        'logOut': 'salir',
        'logs': 'logs',
        'manufacturer': 'fabricante',
        'margin': 'margen',
        'maxToReserve': 'máximo en la reserva',
        'military': 'militar',
        'minReserver': 'reserva mínima',
        'minToReserve': 'mínimo en la reserva',
        'minToPay': 'mínimo en pago parcial',
        'minToPayWeb': 'mínimo en pago parcial para web',
        'minToPayWebTooltip': 'porcentaje para el pago parcial en la web. si es 0 o se borra no se permite pago parcial en la web',
        'minutes': 'minutos',
        'model': 'modelo',
        'modelo': 'modelo',
        'moduleApp': 'app',
        'moduleCollaborator': 'colaborador',
        'moduleEcommerce': 'e-commerce',
        'moduleVirtual': 'virtual',
        'money': 'moneda',
        'moneys': 'monedas',
        'month': 'mes',
        'moto': 'moto',
        'motoAgua': 'motoAgua',
        'mr_mrs': 'Sr/Sra',
        'museo': 'museo',
        'myAccount': 'mi cuenta',
        'name': 'nombre',
        'nameOta': 'nombre',
        'nameServiceIn': 'nombre del servicio en',
        'net': 'neto',
        'netAmount': 'base imponible',
        'no': 'no',
        'noCopiedClipboard': 'no se ha podido copiar al portapapels',
        'noActive': 'no activo',
        'noCollaborator': 'No soy colaborador',
        'noDataShow': 'no hay datos que mostrar',
        'notAvailable': 'no disponible',
        'none': 'ninguna',
        'noOperator': 'no soy colaborador de proveedor de experiencias',
        'noOperators': 'no tengo aún proveedores de experiencias para colaborar',
        'noteNotShareToken': 'Nota: No comparta ni haga público el private api token',
        'nothingModified': 'no se han realizado cambios',
        'notHourSelected': 'falta seleccionar horas en algún servicio',
        'noVirtualUsers': 'no hay usuarios virtuales',
        'number': 'numero',
        'numberSI': 'nº factura',
        'numericCode': 'código numérico',
        'numero': 'número de ticket',
        'odd': 'impar',
        'of': 'de',
        'offset': 'separación',
        'offsetRow': 'separación fila',
        'offsetTop': 'separación arriba',
        'offsetBottom': 'separación abajo',
        'offsetLeft': 'separación izquierda',
        'offsetRight': 'separación derecha',
        'ok': 'aceptar',
        'okRange': 'Aplicar a rango',
        'open': 'apertura',
        'operator': 'prestador',
        'operatorName': 'prestador',
        'operatorGeneralSales': 'ventas de colaboradores',
        'operario': 'operario',
        'operationlines': 'líneas de operación',
        'operationline': 'línea de operación',
        'operationLine': 'línea de operación',
        'operationLineName': 'línea de operación',
        'operatorTickets': 'tickets de revendedores',
        'otas': 'otas',
        'other': 'otro',
        'othered': 'otros pagos',
        'origin': 'origen',
        'out': 'salida',
        'owner': 'propietario',
        'orphan': 'sin familia',
        'packet': 'paquete',
        'packetName': 'paquete',
        'packets': 'paquetes',
        'packetsales': 'tickets paquetes',
        'packetticket': 'paquete',
        'packettickets': 'paquetes',
        'paid': 'pagado',
        'pair': 'par',
        'panoramica': 'panoramica',
        'parael': 'para el',
        'paraUsarEntre': 'para usar entre',
        'paraUsarHasta': 'para usar hasta',
        'paraValidarEntre': 'para validar entre',
        'parcialAvailable': 'parcialmente \ndisponible',
        'parqueAtracciones': 'evento',
        'parent': 'padre',
        'partialClose': 'cierre parcial',
        'passenger': 'pasajero',
        'passengers': 'pasajeros',
        'passengercategories': 'categorias de pasajero',
        'password': 'contraseña',
        'patin': 'patin',
        'payDue': 'completar pago',
        'payments': 'pagos',
        'paymentCard': 'pagado tarjeta',
        'paymentCash': 'pagado efectivo',
        'paymentCredit': 'pagado en crédito',
        'paymentOther': 'pago en otros métodos',
        'paymentTransfer': 'pago en transferencia',
        'percentage': 'porcentaje',
        'phone': 'teléfono',
        'pickUpLocations': 'lugar de recogida',
        'physicalPOS': 'terminal físico',
        'policy': 'política',
        'previous': 'anterior ',
        'price': 'precio',
        'prices': 'precios',
        'pricesForAfiliate': 'precios para afiliado',
        'pricesForCollaborator': 'precios para colaborador',
        'pricesNet': 'precios neto',
        'priceWithTax': 'precio con impuesto',
        'priceWithoutTax': 'precio sin impuesto',
        'pricesWithoutTax': 'precios (sin impuestos)',
        'pricesIdaVueltaWithoutTax': 'precios ida-vuelta (sin impuestos)',
        'primary': 'principal',
        'primaryMoney': 'moneda principal',
        'print': 'imprimir',
        'printPrice': 'imprimir precio',
        'printPriceTicket': 'Imprime precio en el ticket',
        'privateApiToken': 'private api token',
        'propierties': 'propiedades',
        'province': 'provincia',
        'publicApiToken': 'public api token',
        'quantity': 'cantidad',
        'rangeDate': 'rango de fecha',
        'receiptLayout': 'Plantilla de recibo',
        'receipt_total': 'total',
        'recovery': 'olvidé la contraseña',
        'refund': 'anular',
        'refundBy': 'Cancelado por',
        'refunded': 'abonado',
        'reference': 'referencia',
        'removeImage': 'eliminar imagen',
        'reports': 'informes',
        'reset': 'reiniciar',
        'result': 'resultado',
        'results': 'resultados',
        'right': 'right',
        'role': 'rol',
        'row': 'fila',
        'routes': 'rutas',
        'ruta': 'ruta',
        'saleDate': 'desde',
        'sales': 'ventas',
        'save': 'guardar',
        'saved': 'guardado',
        'schedules': 'horarios',
        'search': 'buscar',
        'secondary': 'secundario',
        'sellBy': 'vendido por',
        'seller': 'vendedor',
        'send': 'enviar',
        'senior': 'mayor',
        'sequent': 'consecutivo',
        'serial': 'numero de serie',
        'serviceDescription': 'descripción del servicio',
        'serviceDuration': 'duración del servicio',
        'serviceDurationTooltip': 'duración del servicio',
        'serviceName': 'servicio',
        'serviceWithHourUse': 'Servicio con hora de uso',
        'serviceWithVehiculo': 'marcar para servicio prestado con vehículo',
        'servicio': 'servicio',
        'settings': 'configuración',
        'settingcashmovements': 'configuración movimientos de caja',
        'showEntries': 'mostrar',
        'showCredentialsConnectEcommerce': 'A continuación se muestra las credenciales necesarias para conectar Ticando con su ecommerce.',
        'showing': 'mostrando',
        'si': 'si',
        'simulator': 'simulador',
        'sinValidar': 'sin validar',
        'soldTo': 'vendido a',
        'start': 'comienza',
        'start_at': 'comienza',
        'state': 'estado',
        'status': 'Estado',
        'stock': 'stock',
        'stockable': 'almacenable',
        'stretch': 'servicio',
        'stretches': 'servicios',
        'stretchesSelected': 'servicios seleccionados',
        'stretchValues': 'servicios incluidos',
        'student': 'estudiante',
        'supervisor': 'supervisor',
        'tag': 'etiqueta',
        'tags': 'etiquetas',
        'tax': 'impuesto',
        'taxBase': 'base impuestos',
        'taxAmount': 'impuestos',
        'taxes': 'impuestos',
        'telephone': 'teléfono',
        'terminal': 'terminal de venta',
        'terminalnumero': 'número',
        'terminalPhysicalPOS': 'terminal POS',
        'terminalSale': 'terminal de venta',
        'terminalVirtual': 'terminal virtual',
        'termsDataweb': 'términos y condiciones',
        'ticket': 'ticket',
        'tickets': 'tickets',
        'ticketsRefunded': 'tickets cancelados',
        'timeAdvance': 'tiempo anterior para validar ticket',
        'timeAfterValidateTicket': 'tiempo posterior a hora de uso para validar ticket (en minutos)',
        'timeBeforeValidateTicket': 'tiempo anterior a hora de uso para validar ticket (en minutos)',
        'timeDelay': 'tiempo posterior para validar ticket',
        'timeExpiration': 'válido durante',
        'timeExpirationHour': 'minutos de validez para el ticket a partir de hora de uso',
        'timeFirstValidateTicket': 'tiempo para validar el ticket la primera vez a partir de la fecha de venta (en días). \'0\' para el día actual',
        'timeMaxCancelTicket': 'Tiempo máximo para cancelar ticket validado después de haberlo emitido. (en minutos)',
        'timeUseAfterValidaton': 'Tiempo que se podrá usar el ticket a partir de la validación (en horas). HopOn HopOff o Vuelta. \'0\' para el resto del día (hasta las 23:59)',
        'tipoPago': 'método de pago',
        'timeCancel': 'tiempo cancelación',
        'timeUse': 'Tiempo de uso',
        'tin': 'NIF-CIF-cédula jurídica ',
        'tinIS': 'identificador fiscal para facturación',
        'tinISTooltip': "c\u00F3digo de identificaci\u00F3n fiscal de la empresa que va a emitir la factura de la venta de este servicio. El c\u00F3digo introducido saldr\u00E1 visible en el ticket",
        'to': 'hasta',
        'today': 'hoy',
        'toRange': 'hasta',
        'total': 'total',
        'totalCanceled': 'total cancelado',
        'totalCash': 'total efectivo',
        'totalCard': 'total tarjeta',
        'totalDiscount': 'total descuento',
        'totalRefund': 'total cancelado',
        'totalCredit': 'total crédito',
        'totalCreditCanceled': 'total crédito cancelado',
        'totalCheckins': 'total checkins',
        'totalDescuento': 'total descuento',
        'totalNet': 'total neto',
        'totalOther': 'total otros',
        'totalSales': 'total ventas',
        'totalTickets': 'total tickets',
        'totalTranfer': 'total tranfer.',
        'tradename': 'nombre comercial',
        'tramoHora': 'servicio con horario',
        'tramoHorario': 'horario',
        'transf': 'transf.',
        'transfer': 'transferencia',
        'transferService': 'servicio de transfer',
        'transferServiceTooltip': 'mostrará campos lugar de recogida, lugar de bajada y vuelo en datos de contacto',
        'tranvia': 'tranvia',
        'transfered': 'total por transferencia',
        'trenecito': 'trenecito',
        'trenParada': 'trenParada',
        'tutorialCivitrip': 'tutorial Civitrip',
        'type': 'tipo',
        'typeMaxBeforeReserve': 'seleccione tipo de antes para reservar',
        'typeMaxBeforeReserveTooltip': 'seleccione tipo de antes para reservar, puede ser por horas o por días',
        'typeMaxToReserve': 'seleccione tipo de maximo para reservar',
        'typeMaxToReserveTooltip': 'seleccione tipo de maximo para reservar, puede ser por días, por meses o una fecha',
        'typeMinToPay': 'tipo de pago mínimo',
        'typeMovement': 'tipo movimiento',
        'typePassengers': 'tipo de pasajero',
        'typeDiscount': 'tipo de descuento',
        'typeSale': 'tipo de venta',
        'typePrice': 'cálculo del precio',
        'typeVehicle': 'tipo vehículo',
        'unitary': 'servico que se reserva completo',
        'unitaryTooltip': 'servico que se reserva completo independientemente del número de pasajeros que se seleccionen',
        'unitName': 'nombre unidad',
        'unitNameTooltip': 'nombre para nombrar la unidad por ejemplo: ATV, buggy, moto acuática, canoa, ...',
        'units': 'unidades',
        'unitsTooltip': 'cantidad que dispone el servicio. Por ejemplo número de vehículos',
        'unpaid': 'debido',
        'update': 'actualizar',
        'usedGauges': 'personas dentro',
        'username': 'usuario',
        'user': 'usuario',
        'users': 'usuarios',
        'validoHasta': 'válido hasta',
        'validoPara': 'válido para',
        'validated': 'validados',
        'valid': 'válido',
        'value': 'valor',
        'valueMaxBeforeReserve': 'valor antes de reservar',
        'valueMaxBeforeReserveTooltip': 'tiempo anterior al servicio para no admitir reservas (en horas o días)',
        'valueMaxToReserve': 'valor máximo para reservar',
        'valueMaxToReserveTooltip': 'hasta cuando se admite reservas (en días, meses o hasta una fecha)',
        'vehicles': 'vehículos',
        'virtual': 'vendedor virtual',
        'virtualTickets': 'tickets virtual',
        'virtualUsers': 'usuarios virtuales',
        'voucher': 'voucher',
        'vouchers': 'vouchers',
        'vuelta': 'ida-vuelta',
        'web': 'web',
        'webExpiration': 'tiempo para pagar en el carro web',
        'webExpirationMessage': 'tiempo que se reserva el servicio en el carrito hasta que se produce el pago',
        'webMoney': 'moneda para la web',
        'week': 'semana',
        'wharehouse': 'mi catálogo',
        'withoutTax': 'sin impuestos',
        'withVehicle': 'con vehículo',
        'year': 'año',
        'yEl': 'y el',
        'yes': 'si',
        'zip': 'código postal',
        'modules': 'módulos',
        'moduleMarketing': 'marketing',
        'civitrip': 'civitrip',
        'checkVersion': 'comprobar versión',
        'error': {
            'unableConnect': 'imposible conectar, comprobar conexión',
            'tryAgainLater': 'intentar de nuevo más tarde',
            'loginAgain': 'iniciar sesión de nuevo',
            'userNoAccess': 'acceso prohibido para este tipo de usuario'
        }
    },
    'en': {
        '0-introduccion': 'Introduction',
        '10-listadoTickets': 'Ticket List',
        '11-crearPaquete': 'Create a package\n',
        '12-familiasArticulos': 'Families of article',
        '1-crearnegocio': 'Create bussiness',
        '1-introduccion': '01. Introduction',
        '2-crearUsuario': 'Create user',
        '2-negocios': '02. Bussiness',
        '3-modificarUsuario': 'Modify user',
        '3-usuarios': '03. User',
        '4-categoriasPasajeroHorarios': '04. Passenger category, schedules',
        '4-crearCategoriaPasajero': 'Create passenger category ',
        '5-impuestoExtrasMonedas': '05. Taxes, extras, moneys',
        '5-Linea de operacion': 'Operating line',
        '6-lineaOperacion': '06. Operating line',
        '6-servicio ida y vuelta': 'Round-trip service',
        '7-ServicioHopONHopoff': 'HopONhopOFF Service',
        '7-servicios': '07. Services',
        '8-crearHorarios': 'Create schedules',
        '9-servicioConHorario': 'Scheduled service',
        'acount': 'My account',
        'actives': 'Assets',
        'activo': 'Asset',
        'add': 'Add',
        'additional': 'Adittional',
        'additionalInformation': 'Adittional information',
        'additionalNote': 'Additional note',
        'address': 'Address',
        'addRow': 'Add row',
        'addSeats': 'Add seats',
        'aditional': 'Aditional information',
        'aditionalInfo': 'Additional service information at the end of the ticket ',
        'administrator': 'Administrator',
        'adult': 'Adult',
        'typePassenger': {
            'adult': 'adult',
            'child': 'child',
            'handicapped': 'handicapped',
            'infant': 'infant',
            'military': 'military',
            'pensioner': 'pensioner',
            'resident': 'resident',
            'senior': 'senior',
            'student': 'student'
        },
        'afiliate': 'Affiliate',
        'afiliateName': 'Affiliate name',
        'afiliates': 'Affiliates',
        'all': 'All',
        'allAfiliates': 'All Affiliates',
        'allBusiness': 'All businesses',
        'allDiscounts': 'Code discounts',
        'allTickets': 'All tickets',
        'alphabeticCode': 'Alphabetic code',
        'alpha_dash_space': 'The :attribute field should only contain letters, numbers, hyphens and spaces (spaces not at the end).',
        'amount_paid': 'Amount paid',
        'amount_paid_boxoffice': 'amount charged at the box office',
        'aPartirValidacion': 'From the first validation',
        'appliedCorrectly': 'correctly applied nets',
        'appliedError': 'error applying nets',
        'applyNet': 'apply net to all shared services',
        'applyCommission': 'the commission will be applied, the current values will be overwritten',
        'appName': 'backoffice web',
        'areaconfig': 'Setting area',
        'article': 'article',
        'articles': 'articles',
        'articleTickets': 'Article tickets',
        'as': 'As',
        'askAdditionalInformation': 'request any additional information',
        'atraccion': 'attraction',
        'autobus': 'bus',
        'available': 'Available',
        'avion': 'Plane',
        'back': 'back',
        'barco': 'ship',
        'barcode': 'barcode',
        'beCollaborator': 'Be collaborator',
        'bicicleta': 'bicycle',
        'block': 'Block',
        'bookingFee': 'booking fee',
        'branch': 'branch',
        'branches': 'branches',
        'brand': 'brand',
        'buceo': 'Diving',
        'bus': 'bus',
        'business': 'business',
        'businessName': 'Fiscal name',
        'businessunit': 'business unit',
        'businessUnit': 'business unit',
        'businessUnitName': 'Business name',
        'businessunits': 'business units',
        'businessUnits': 'business units',
        'busParada': 'bus stop',
        'busTuristico': 'Bus hop-ON hop-OFF',
        'byHours': 'by hours',
        'byGroup': 'Group',
        'byPassenger': 'By Passenger',
        'calculadora_precios_sin_iva': 'price calculator without VAT',
        'calendar': 'Calendar',
        'calendarAvailable': 'Availability in calendar',
        'calendarMonth': 'Month of calendar',
        'cancel': 'Cancel',
        'canceled': 'canceled',
        'canceledNoModified': 'ticket canceled, cannot be modified',
        'canceledTickets': 'Cancelled tickets',
        'capacity': 'Capacity',
        'card': 'Card',
        'cardAmount': 'card amount',
        'carded': 'Total on credit card',
        'cash': 'Cash',
        'cashAmount': 'cash amount',
        'cashDesk': 'cash desk',
        'cashDeskClosures': 'Cash Desk Closures',
        'cashDeskOpen': 'cash desk already opened',
        'cashed': 'cashed',
        'categoriaPasajero': 'passenger category',
        'category': 'category',
        'categories': 'categories',
        'changeDatebook': 'change use date',
        'checkins': 'checkins',
        'child': 'child',
        'city': 'city',
        'client': 'client',
        'close': 'close',
        'code': 'code',
        'codeDiscount': 'code discount',
        'collaboratorCode': 'collaborator code',
        'collaboratorEmail': 'email collaborator',
        'collaboratorName': 'collaborator name',
        'collaboratorPacket': 'collaborator packet',
        'collaboratorpackets': 'collaborator packets',
        'collaborators': 'collaborator',
        'collaboratorService': 'collaborator service',
        'collaboratorspackets': 'collaborators packets ',
        'collaboratorStretch': 'collaborator stretch',
        'collaboratorstretches': 'collaborator stretches',
        'collaboratorStretchValues': 'value of the collaboration service\n',
        'collaboratorTickets': 'sale to collaborators\n',
        'collaboratorTin': 'CIF contributor',
        'collaboratortretches': 'services in partnership',
        'commission': 'commission',
        'concepto': 'concept',
        'confirmDelete': 'confirm delete?',
        'confirmDisable': 'confirm disable?',
        'confirmEnable': 'confirm enable?',
        'contactName': 'contact name',
        'contactPhone': 'contact phone',
        'copiedToClipboard': 'copied to clipboard',
        'cost': 'cost',
        'create': 'create',
        'credit': 'credit',
        'creditCanceled': 'credit cancelled',
        'credited': 'credited',
        'currency': 'currency',
        'custom': 'custom',
        'customed': 'customed',
        'customers': 'customers',
        'customized': 'customized',
        'dashboard': 'dashboard',
        'dashboardticket': 'dashboard ticket',
        'dataWeb': 'web data',
        'date': 'date',
        'datebook': 'use date',
        'dateBook': 'date book',
        'datecheck': 'date check',
        'dateClose': 'date close',
        'dateOpen': 'date open',
        'daterefund': 'date refund',
        'dateRefund': 'date of refund',
        'dateSI': 'invoice date',
        'datevalited': 'date valited',
        'dateValited': 'date validated',
        'day': 'day',
        'delayTime': 'delay time',
        'delete': 'delete',
        'departureTime': 'departure time',
        'description': 'description',
        'desde': 'from',
        'destination': 'destination',
        'devices': 'devices',
        'disable': 'disable',
        'disableAll': 'disable all',
        'disabled': 'disabled',
        'disabled_at': 'disbled at',
        'disableMonth': 'disable month',
        'disableTerminal': 'disable on Android terminal\n',
        'disableTerminalTooltip': 'select to not allow to sell on android terminal',
        'disableVirtual': 'disable in virtual',
        'disableVirtualTooltip': 'select to not allow virtual selling',
        'disableWeb': 'disable on website',
        'disableWebTooltip': 'select to not allow web selling',
        'discount': 'discount',
        'discountcodes': 'discount codes',
        'discountreasons': 'discount reason',
        'discountTickets': 'discount tickets',
        'download': 'download',
        'due': 'due',
        'edit': 'edit',
        'email': 'email',
        'emails': 'emails',
        'emailsToSend': 'email for notification of booking',
        'enable': 'enable',
        'enableAll': 'enable all',
        'enabled': 'enabled',
        'enableMonth': 'enable month',
        'endHour': 'end hour',
        'error_array_emails_comma': 'error in email list (enter comma-separated and no blanks)',
        'excursion': 'trip',
        'expiredLicense': 'expired license',
        'expire': 'expire',
        'expire_at': 'expire',
        'extras': 'extras',
        'families': 'families',
        'family': 'family',
        'fix': 'fixed',
        'following': 'next',
        'footer': 'footer',
        'from': 'from',
        'funcion': 'show',
        'funicular': 'cableway',
        'generalSales': 'general sales',
        'handicapped': 'handicapped',
        'hasta': 'to',
        'headboards': 'ticket headboards',
        'header': 'header',
        'helicopero': 'helicopter',
        'help': 'help',
        'hoponHopoff': 'HopON-HopOFF',
        'hopOnOff': 'hopOnOff',
        'hora': 'hour',
        'horasIda': 'departure times',
        'horasVuelta': 'return times',
        'hours': 'hours',
        'id': 'ID',
        'ida': 'way',
        'idavuelta': 'round trip',
        'idaVuelta': 'round trip',
        'image': 'image',
        'imageProperties': 'image in jpg format and with a minimun of 600x600 px',
        'imagesDataweb': 'images',
        'informationWeb': 'web information',
        'in': 'in',
        'infant': 'infant',
        'info': 'info',
        'infoDataweb': 'description',
        'initHour': 'start time',
        'invoice': 'invoice',
        'invoiceSimple': 'invoice simple',
        'lancha': 'boat',
        'lastname': 'last name',
        'left': 'left',
        'license': 'license',
        'licenses': 'licences',
        'listMonth': 'month list',
        'limitUse': 'use limit',
        'logIn': 'log in',
        'error': {
            'loginAgain': 'log in again',
            'tryAgainLater': 'try again later',
            'unableConnect': 'unable to connect, check network',
            'userNoAccess': 'prohibited access for this type of user'
        },
        'logOut': 'log out',
        'manufacturer': 'manufacturer',
        'margin': 'margin',
        'maxToReserve': 'maximum to reserve',
        'military': 'military',
        'minReserver': 'minimum reservation',
        'minToPayWeb': 'percentage for partial payment by web',
        'minToPayWebTooltip': 'percentage for partial payment on the web. \nIf 0 or deleted no partial payment is allowed on the web',
        'minToReserve': 'minimum for reservation',
        'minutes': 'minutes',
        'model': 'model',
        'modelo': 'model',
        'money': 'coin',
        'moneys': 'currencies',
        'month': 'month',
        'moto': 'moto',
        'motoAgua': 'jet ski',
        'mr_mrs': 'Sir/Mme',
        'museo': 'museum',
        'myAccount': 'my account ',
        'name': 'name',
        'nameServiceIn': 'name service',
        'netAmount': 'net amount',
        'no': 'no',
        'noCopiedClipboard': 'could not copy to clipboard',
        'noDataShow': 'no data to show',
        'none': 'none',
        'notAvailable': 'not available',
        'nothingModified': 'nothing modified',
        'notHourSelected': 'not hour selected',
        'number': 'number',
        'numericCode': 'numeric code ',
        'numero': 'ticket number',
        'odd': 'odd',
        'of': 'of',
        'offset': 'separation',
        'offsetBottom': 'offset bottom',
        'offsetLeft': 'offset left ',
        'offsetRight': 'offset right',
        'offsetRow': 'row spacing',
        'offsetTop': 'offset top',
        'ok': 'ok',
        'open': 'open',
        'operario': '',
        'operationline': 'operation line',
        'operationLine': 'operation line',
        'operationLineName': 'operation line name',
        'operationlines': 'operation lines',
        'operator': 'operator',
        'operatorName': 'operator name',
        'operatorTickets': 'operator tickets',
        'origin': 'origin',
        'orphan': 'without family',
        'otas': 'otas',
        'other': 'other',
        'othered': 'other payments',
        'out': 'out',
        'owner': 'owner',
        'packet': 'packet',
        'packetName': 'packet name',
        'packets': 'packets',
        'packetsales': 'packet sales ',
        'packetticket': 'packet ticket',
        'packettickets': 'packet tickets',
        'paid': 'paid',
        'pair': 'pair',
        'panoramica': 'panoramic',
        'parael': 'for the',
        'paraUsarEntre': 'to use from',
        'paraUsarHasta': 'to use to',
        'paraValidarEntre': 'to validate to',
        'parcialAvailable': 'partially available',
        'parent': 'parent',
        'parqueAtracciones': 'theme park',
        'partialClose': 'partial close',
        'passenger': 'passenger',
        'passengercategories': 'passenger categories',
        'passengers': 'passengers',
        'password': 'password',
        'patin': 'skate',
        'payDue': 'pay due',
        'paymentCard': 'card payment',
        'paymentCash': 'cash paid',
        'paymentCredit': 'paid by credit',
        'paymentOther': 'other payments',
        'payments': 'payments',
        'paymentTransfer': 'transfer payment',
        'percentage': 'percentage',
        'phone': 'phone',
        'physicalPOS': 'physical IPOS',
        'policy': 'policy',
        'previous': 'previous',
        'price': 'price',
        'prices': 'prices',
        'pricesForAfiliate': 'prices for afiliate',
        'pricesForCollaborator': 'prices for collaborator',
        'pricesIdaVueltaWithoutTax': 'prices round trip (without taxes)',
        'pricesWithoutTax': 'prices (without tax)',
        'priceWithoutTax': 'price (without tax)',
        'priceWithTax': 'price (with taxes)',
        'primary': 'principal',
        'primaryMoney': 'main currency',
        'print': 'print',
        'printPrice': 'print price',
        'printPriceTicket': 'print price on ticket',
        'propierties': 'properties',
        'province': 'province',
        'quantity': 'quantity',
        'rangeDate': 'date range',
        'receiptLayout': 'receipt layout',
        'receipt_total': 'total',
        'recovery': 'i forgot the password',
        'reference': 'reference',
        'refund': 'refund',
        'refunded': 'refunded',
        'removeImage': 'remove image',
        'reports': 'reports',
        'reset': 'reset',
        'result': 'result',
        'results': 'results',
        'right': 'right',
        'role': 'rol',
        'routes': 'routes',
        'row': 'row',
        'ruta': 'route',
        'saleDate': 'since',
        'sales': 'sales',
        'save': 'save',
        'schedules': 'schedules',
        'search': 'search',
        'secondary': 'secondary',
        'sellBy': 'sold by',
        'seller': 'seller',
        'send': 'send',
        'senior': 'senior',
        'sequent': 'sequent',
        'serial': 'serial number',
        'serviceDescription': 'service description',
        'serviceDuration': 'service life',
        'serviceDurationTooltip': 'service duration tool tip',
        'serviceName': 'service name ',
        'serviceWithHourUse': 'service with time of use',
        'serviceWithVehiculo': 'mark for service provided with vehicle',
        'servicio': 'service',
        'settingcashmovements': 'cash setting movements',
        'settings': 'setting',
        'showEntries': 'show entries',
        'showing': 'showing',
        'si': 'yes',
        'simulator': 'simulator',
        'sinValidar': 'not validated',
        'soldTo': 'sold to ',
        'start': 'start',
        'start_at': 'start',
        'state': 'state',
        'status': 'status',
        'stock': 'stock',
        'stockable': 'stockable',
        'stretch': 'sevice',
        'stretches': 'services',
        'stretchesSelected': 'sevices selected',
        'stretchValues': 'service included',
        'student': 'student',
        'supervisor': 'supervisor',
        'tag': 'tag',
        'tags': 'tags',
        'tax': 'tax',
        'taxAmount': 'tax amount',
        'taxBase': 'tax base',
        'taxes': 'taxes',
        'telephone': 'telephone',
        'terminal': 'sale terminal',
        'terminalnumero': 'terminal number',
        'terminalPhysicalPOS': 'temrinal physical',
        'terminalSale': 'terminal sale',
        'terminalVirtual': 'virtual terminal',
        'termsDataweb': 'terms and conditions',
        'ticket': 'ticket',
        'tickets': 'tickets',
        'ticketsRefunded': 'tickets refunded',
        'timeAdvance': 'time before use time to validate the ticket (in minutes)',
        'timeAfterValidateTicket': 'time after use to validate ticket (in minutes)',
        'timeBeforeValidateTicket': 'time before use to validate ticket (in minutes)',
        'timeCancel': 'maximum time to cancel ticket (in minutes)',
        'timeDelay': 'time later to validate ticket',
        'timeExpiration': 'valid for',
        'timeExpirationHour': 'minutes of validity of the ticket from the time of use',
        'timeFirstValidateTicket': 'time to validate the ticket the first time from the date of sale (in days). \' 0\' for the current day',
        'timeMaxCancelTicket': 'Maximum time to cancel validated ticket after issuance. (in minutes)',
        'timeUse': 'time of use',
        'timeUseAfterValidaton': 'Time the ticket can be used from validation (in hours). HopOn HopOff or Vuelta. \'0\' for the rest of the day (until 23:59)',
        'tin': 'tin',
        'tipoPago': 'payment method',
        'to': 'up to',
        'today': 'today',
        'total': 'total',
        'totalCanceled': 'total cancelled',
        'totalCard': 'total card',
        'totalCash': 'total cash',
        'totalCheckins': 'total checkin',
        'totalCredit': 'total credit',
        'totalCreditCanceled': 'total credit cancelled',
        'totalDescuento': 'total discount',
        'totalDiscount': 'total discount',
        'totalOther': 'total other',
        'totalRefund': 'total refund',
        'totalSales': 'total sales',
        'totalTickets': 'total tickets',
        'totalTranfer': 'total transfer',
        'tradename': 'trade name',
        'tramoHora': 'valid for a schedule',
        'tramoHorario': 'schedule',
        'transf': 'transf.',
        'transfer': 'transfer',
        'transfered': 'total by transfer',
        'tranvia': 'trolley car',
        'trenecito': 'little train',
        'trenParada': 'train stop',
        'tutorialCivitrip': 'Civitrip tutorial',
        'type': 'type',
        'typeMovement': 'type of movement',
        'typePassengers': 'type of passenger',
        'typeDiscount': 'discount type',
        'typePrice': 'price calculation',
        'typeSale': 'type of sale',
        'typeVehicle': 'type of vehicle',
        'unitary': 'service that is fully booked',
        'unitaryTooltip': 'service that is fully booked regardless of the number of passengers selected',
        'units': 'units',
        'unitsTooltip': 'quantity available. For example number of vehicles',
        'unpaid': 'unpaid',
        'update': 'update',
        'usedGauges': 'people inside',
        'user': 'user',
        'username': 'user name',
        'users': 'users',
        'validated': 'validated',
        'validoHasta': 'valid up to',
        'validoPara': 'valid for',
        'value': 'value',
        'vehicles': 'vehicles',
        'virtual': 'virtual seller',
        'virtualTickets': 'virtual tickets',
        'voucher': 'voucher',
        'vouchers': 'vouchers',
        'vuelta': 'round trip',
        'web': 'web',
        'webExpiration': 'time to pay on the web cart',
        'webExpirationMessage': 'time the service is reserved in the cart until payment occurs',
        'webMoney': 'web money',
        'week': 'week',
        'wharehouse': 'goods',
        'withoutTax': 'without tax',
        'withVehicle': 'with vehicle',
        'year': 'year',
        'yEl': 'and he',
        'yes': 'yes',
        'zip': 'postal code',
        'modules': 'modules',
        'moduleMarketing': 'marketing',
        'civitrip': 'civitrip',
        'checkVersion': 'check version',
        'byDate': 'by date',
        'byDays': 'by days',
        'byMonth': 'by month',
        'bySaleDate': 'by sale date',
        'byUseDate': 'by use date',
        'fromRange': 'from',
        'toRange': 'to',
        'dateCheck': 'issued',
        'dateMaxToReserve': 'maximum date to reserve',
        'descriptionAppModule': 'module for sales to end customers with company staff intervention using a physical Android mobile device through the app',
        'descriptionCollabortorModule': 'module that allows collaborative sales of experiences-services from other providers',
        'descriptionEcommerceModule': 'module for sales to end customers without company staff intervention',
        'descriptionVirtualModule': 'module for sales to end customers with company staff intervention through a virtual device',
        'moduleApp': 'app',
        'moduleCollaborator': 'collaborator',
        'moduleEcommerce': 'e-commerce',
        'moduleVirtual': 'virtual',
        'apiToken': 'private api token',
        'privateApiToken': 'private api token',
        'publicApiToken': 'public api token',
        'noteNotShareToken': 'Note: Do not share or make public the private api token',
        'showCredentialsConnectEcommerce': 'Below are the credentials needed to connect Ticando with your ecommerce.',
    },
    'it': {
        '0-introduccion': 'Introduzione',
        '10-listadoTickets': 'Elenco dei biglietti',
        '11-crearPaquete': 'Crea pachetto',
        '12-familiasArticulos': 'Famiglie di oggetti',
        '1-crearnegocio': 'Creare attività',
        '1-introduccion': '01. Introduzione',
        '2-crearUsuario': 'Crea utente',
        '2-negocios': '02. Attività',
        '3-modificarUsuario': 'Modificare utente',
        '3-usuarios': '03. Utente',
        '4-categoriasPasajeroHorarios': '04. Categoria di passaggero, orari',
        '4-crearCategoriaPasajero': 'Crea categoria di passeggero ',
        '5-impuestoExtrasMonedas': '05. Tasse, extra, monete',
        '5-Linea de operacion': 'Linea di condotta ',
        '6-lineaOperacion': '06. Línea di condotta',
        '6-servicio ida y vuelta': 'Servizio di andata e ritorno',
        '7-ServicioHopONHopoff': 'Servizio hopOnhopOFF',
        '7-servicios': '07. Servizi',
        '8-crearHorarios': 'Creare programmi',
        '9-servicioConHorario': 'Servizio con orario',
        'acount': 'Mio conto',
        'actives': 'Attivi',
        'activo': 'Attivo',
        'add': 'Aggiungere',
        'additional': 'Agiunttivo',
        'additionalInformation': 'Informazioni aggiuntive',
        'additionalNote': 'Nota agiunttiva',
        'address': 'Direzzione',
        'addRow': 'Aggiungi riga',
        'addSeats': 'Aggiungere posti a sedere',
        'aditional': 'Informazione aggiuntive',
        'aditionalInfo': 'Informazione aggiuntive sul servizio (verranno stampate sul biglietto)',
        'administrator': 'Gestore',
        'adult': 'Adulti',
        'typePassenger': {
            'adult': 'adulti',
            'child': 'bambino',
            'handicapped': 'handicappato',
            'infant': 'bambino',
            'military': 'militare',
            'pensioner': 'pensionato',
            'resident': 'residente',
            'senior': 'senior',
            'student': 'estudente'
        },
        'afiliate': 'Affiliato',
        'afiliateName': 'Nome di affiliato',
        'afiliates': 'Affiliati',
        'all': 'Tutti',
        'allAfiliates': 'Tutti gli affiliati',
        'allBusiness': 'Tutti gli affari',
        'allDiscounts': 'Codice sconti',
        'allTickets': 'Tutti i biglietti',
        'alphabeticCode': 'Codice alfabetico',
        'alpha_dash_space': 'Il campo :attribute deve contenere solo lettere, numeri, trattini e spazi (spazi non alla fine).',
        'amount_paid': 'Importo pagato',
        'amount_paid_boxoffice': 'Importo pagato al botteghino',
        'aPartirValidacion': 'A partire dalla prima convalida ',
        'apiToken': 'token api privato',
        'appliedCorrectly': 'reti applicate correttamente',
        'appliedError': 'errore nell\'applicazione delle reti',
        'applyNet': 'applica net a tutti i servizi condivisi',
        'applyCommission': 'verrà applicata la commissione, i valori correnti verranno sovrascritti',
        'appName': 'Tpv Web',
        'areaconfig': 'Area di configurazione',
        'article': 'Prodotto',
        'articles': 'Prodotti',
        'articleTickets': 'Ticket prodotti',
        'as': 'Come',
        'askAdditionalInformation': 'richiedere qualsiasi informazione aggiuntiva',
        'atraccion': 'Attrazione',
        'autobus': 'Bus',
        'available': 'Disponibile',
        'avion': 'Aereo',
        'back': 'indietro',
        'barco': 'Barca',
        'barcode': 'Codice a barre',
        'beCollaborator': 'Essere un collaboratore',
        'bicicleta': 'Bicicletta',
        'block': 'Bloccato',
        'bookingFee': 'booking fee',
        'branch': 'Filiale',
        'branches': 'Filiali',
        'brand': 'Marchio',
        'buceo': 'Immerzione',
        'bus': 'Bus',
        'business': 'attività',
        'businessName': 'Nome fiscale',
        'businessunit': 'Attivitá',
        'businessUnit': 'Attivitá',
        'businessUnitName': 'Nome d\'attivitá',
        'businessunits': 'Attivitás',
        'businessUnits': 'Attivitás',
        'busParada': 'Fermata dell\'autobus',
        'busTuristico': 'Bus hop-ON hop-OFF',
        'byHours': 'por ore',
        'byGroup': 'Gruppo',
        'byPassenger': 'Por passaggero',
        'calculadora_precios_sin_iva': 'Calcolatore di prezzi senza tasse',
        'calendar': 'cCalendario',
        'calendarAvailable': 'disponibilità in calendario',
        'calendarMonth': 'mese de calendario',
        'cancel': 'cancellare',
        'canceled': 'cancellato',
        'canceledNoModified': 'biglietto annullato, non modificabile',
        'canceledTickets': 'Biglietti annullati',
        'capacity': 'Capacità',
        'card': 'Carta di credito',
        'cardAmount': 'Costo Carta',
        'carded': 'totale con carta di credito',
        'cash': 'Effetivo',
        'cashAmount': 'Costo Effecttivo ',
        'cashDesk': 'Cassa pagamento in contanti',
        'cashDeskClosures': 'Chiusure di cassa',
        'cashDeskOpen': 'La scatola è già aperta',
        'cashed': 'totale in contanti',
        'categoriaPasajero': 'categoria di passeggero',
        'category': 'categoria',
        'categories': 'categorie',
        'changeDatebook': 'modificare la data di utilizzo',
        'checkins': 'Check-in',
        'city': 'Città',
        'client': 'Cliente',
        'close': 'chiusura',
        'code': 'Codice',
        'codeDiscount': 'codice sconto',
        'collaboratorCode': 'codice collaboratore',
        'collaboratorEmail': 'email di collaboratore',
        'collaboratorName': 'nome collaboratore',
        'collaboratorPacket': 'pacchetto collaboratori',
        'collaboratorpackets': 'pacchetti in collaborazione',
        'collaborators': 'collaboratore',
        'collaboratorService': 'vendita a partner',
        'collaboratorspackets': 'pacchetti di collaborazione',
        'collaboratorStretch': 'servizio in collaborazione',
        'collaboratorstretches': 'servizio in collaborazione',
        'collaboratorStretchValues': 'valore del servizio in collaborazione',
        'collaboratorTickets': 'vendita a partner\n',
        'collaboratorTin': 'codice fiscale collaboratore',
        'collaboratortretches': 'servizi in collaborazione',
        'commission': 'commissione',
        'concepto': 'concetto',
        'confirmDelete': 'confermare eliminare?',
        'confirmDisable': 'Confermare disabilità?',
        'confirmEnable': 'Confermare abilitazione?',
        'contactName': 'persona di contatto',
        'contactPhone': 'telefono di contatto',
        'copiedToClipboard': 'copiato negli appunti',
        'cost': 'costo',
        'create': 'creare',
        'credit': 'credito',
        'creditCanceled': 'credito cancellato',
        'credited': 'totale credito',
        'currency': 'moneta',
        'custom': 'personalizzato',
        'customed': 'personalizzato',
        'customers': 'clienti',
        'customized': 'personalizzato',
        'dashboard': 'pannello di controllo',
        'dashboardticket': 'dashboard ticket',
        'dataWeb': 'dati web',
        'date': 'data',
        'datebook': 'data di utilizzo',
        'dateBook': 'data di prenotazione',
        'datecheck': 'data di emissione',
        'dateClose': 'data di chiusura',
        'dateOpen': 'data di apertura',
        'daterefund': 'data di cancellazione',
        'dateRefund': 'data cancellazione',
        'dateSI': 'data de fattura',
        'datevalited': 'data di convalida',
        'dateValited': 'data di convalida',
        'day': 'giorno',
        'delayTime': 'tempo di ritardo',
        'delete': 'eliminare',
        'departureTime': 'orario di partenza',
        'description': 'descrizione',
        'desde': 'da',
        'destination': 'destinazione',
        'devices': 'dispositivo',
        'disable': 'disabilitare',
        'disableAll': 'disabilita tutto',
        'disabled': 'disabilitare',
        'disabled_at': 'disattivato in',
        'disableMonth': 'disabilitato mese\n',
        'disableTerminal': 'disabilitare sul terminale Android\n',
        'disableTerminalTooltip': 'selezionare per non consentire la vendita sul terminale android',
        'disableVirtual': 'disabilitare su virtuale',
        'disableVirtualTooltip': 'selezionare per non consentire la vendita virtuale',
        'disableWeb': 'disabilitare sul web ',
        'disableWebTooltip': 'selezionare per non consentire la vendita sul web',
        'discount': 'sconto',
        'discountcodes': 'codici sconto',
        'discountreasons': 'motivo sconto',
        'discountTickets': 'biglietti sconto',
        'download': 'scaricare',
        'due': 'termine',
        'edit': 'modificare',
        'email': 'email',
        'emails': 'emails',
        'emailsToSend': 'email per la notifica di prenotazione',
        'enable': 'abilitare',
        'enableAll': 'attivare tutto',
        'enabled': 'attivato',
        'enableMonth': 'abilitare mese',
        'endHour': 'ora di fine',
        'error_array_emails_comma': 'Errore nell\'elenco delle email (inserire separati da virgole e senza spazi vuoti)',
        'excursion': 'escursione',
        'expiredLicense': 'licenza scaduta',
        'expire': 'finisce',
        'expire_at': 'finisce',
        'extras': 'extra',
        'families': 'famiglie di prodotti',
        'family': 'famiglia',
        'fix': 'fixe',
        'following': 'seguente',
        'footer': 'piè',
        'from': 'da',
        'funcion': 'funzione',
        'funicular': 'funicolare',
        'generalSales': 'vendite generali',
        'handicapped': 'handicappato',
        'hasta': 'fino a',
        'headboards': 'intestazioni di ticket',
        'header': 'testata',
        'helicopero': 'elicottero',
        'help': 'aiuta',
        'hoponHopoff': 'Hopon-hopoff',
        'hopOnOff': 'HopOnOff',
        'hora': 'ora',
        'horasIda': 'orari di partenza',
        'horasVuelta': 'orario di ritorno',
        'hours': 'orari',
        'id': 'identificativo',
        'ida': 'andata',
        'idavuelta': 'andata e ritorno',
        'idaVuelta': 'andata e ritorno',
        'image': 'immagine',
        'imageProperties': 'immagine in formato jpg con un minimo di 600x600 px',
        'imagesDataweb': 'immagini',
        'informationWeb': 'informazioni web',
        'in': 'ingresso',
        'infant': 'bambino',
        'info': 'info',
        'infoDataweb': 'descrizione',
        'initHour': 'orario di inizio',
        'invoice': 'fattura',
        'invoiceSimple': 'fattura semplificata',
        'lancha': 'barca ',
        'lastname': 'cognome',
        'left': 'sinistra',
        'license': 'licenza',
        'licenses': 'licenzas',
        'listMonth': 'lista mese',
        'limitUse': 'limite di utilizzo',
        'logIn': 'accedere',
        'error': {
            'loginAgain': 'accedere di nuovo',
            'tryAgainLater': 'riprovare più tardi',
            'unableConnect': 'impossibile collegare, verificare la connessione',
            'userNoAccess': 'accesso vietato per questo tipo di utente'
        },
        'logOut': 'uscire',
        'manufacturer': 'fabbricante',
        'margin': 'margine',
        'maxToReserve': 'massimo nella prenotazione ',
        'military': 'Militare',
        'minReserver': 'riserva minima',
        'minToPayWeb': 'percentuale per pagamento parziale dal web',
        'minToPayWebTooltip': 'percentuale per il pagamento parziale sul web. \nSe è 0 o cancellato non è consentito il pagamento parziale sul web',
        'minToReserve': 'minimo per la prenotazione',
        'minutes': 'minuti',
        'model': 'modello',
        'modelo': 'modello',
        'money': 'moneta',
        'moneys': 'valute',
        'month': 'Mese',
        'moto': 'moto',
        'motoAgua': 'Jet Ski',
        'mr_mrs': 'signore/signora',
        'museo': 'Museo',
        'myAccount': 'mio conto',
        'name': 'nome',
        'nameServiceIn': 'nome del servizio',
        'netAmount': 'base imponibile',
        'no': 'no',
        'noCopiedClipboard': 'impossibile copiare negli appunti',
        'noDataShow': 'non ci sono dati da visualizzare ',
        'none': 'nessuno',
        'notAvailable': 'non disponibile',
        'nothingModified': 'non sono state apportate modifiche',
        'notHourSelected': 'devi selezionare ore su un servizio',
        'number': 'numero',
        'numericCode': 'codice numerico',
        'numero': 'numero di biglietto ',
        'odd': 'dispari',
        'of': 'di',
        'offset': 'separazione',
        'offsetBottom': 'fondo offset ',
        'offsetLeft': 'deviazione a sinistra ',
        'offsetRight': 'separazione a destra ',
        'offsetRow': 'separazione fila',
        'offsetTop': 'separazione in alto',
        'ok': 'ok',
        'open': 'apertura',
        'operario': 'operatore',
        'operationline': 'linea operativa',
        'operationLine': 'linea operativa',
        'operationLineName': 'nome della riga di operazione',
        'operationlines': 'linea operativa',
        'operator': 'operatore',
        'operatorName': 'nome di operatore',
        'operatorTickets': 'biglietti dell\'operatore',
        'origin': 'Origine',
        'orphan': 'niente famiglia',
        'otas': 'otas',
        'other': 'altro',
        'othered': 'altri pagamenti',
        'out': 'uscita',
        'owner': 'propietario',
        'packet': 'pacchetto',
        'packetName': 'nome di pachetto',
        'packets': 'pacchetti',
        'packetsales': 'vendita di pacchetti',
        'packetticket': 'biglietti di pachetto',
        'packettickets': 'bigglietti di pachietto',
        'paid': 'pagato',
        'pair': 'paio',
        'panoramica': 'panoramica',
        'parael': 'per il',
        'paraUsarEntre': 'per l\'uso tra',
        'paraUsarHasta': 'da usare fino',
        'paraValidarEntre': 'per convalidare tra ',
        'parcialAvailable': 'parzialemente disponibile',
        'parent': 'padre',
        'parqueAtracciones': 'parco di divertimenti',
        'partialClose': 'chiusura parziale',
        'passenger': 'passeggero',
        'passengercategories': 'categoria passegero',
        'passengers': 'passageri',
        'password': 'password',
        'patin': 'patino',
        'payDue': 'completare il pagamento',
        'paymentCard': 'pagamento con carta di credito',
        'paymentCash': 'pagato in contanti',
        'paymentCredit': 'pagato in  credito',
        'paymentOther': 'pagamento in altri modi',
        'payments': 'pagamenti',
        'paymentTransfer': 'pagamento con bonifico',
        'percentage': 'percentuale',
        'phone': 'telefono',
        'physicalPOS': 'terminale fisico',
        'policy': 'politica',
        'previous': 'precedente ',
        'price': 'prezzo',
        'prices': 'prezzi',
        'pricesForAfiliate': 'prezzo per gli affiliati',
        'pricesForCollaborator': 'prezzo per i collaboratori',
        'pricesIdaVueltaWithoutTax': 'prezzi di andata e ritorno (tasse escluse)',
        'pricesWithoutTax': 'prezzi (al netto delle imposte)',
        'priceWithoutTax': 'prezzo (al netto delle imposte)',
        'priceWithTax': 'prezzo (con le imposte)',
        'primary': 'principale',
        'primaryMoney': 'valuta principale',
        'print': 'stampare',
        'printPrice': 'stampare il prezzo',
        'printPriceTicket': 'stampa il prezzo sul bigglieto',
        'propierties': 'proprietà',
        'province': 'provincia',
        'quantity': 'quantità',
        'rangeDate': 'intervallo di date',
        'receiptLayout': 'modello di ricevuta',
        'receipt_total': 'totale',
        'recovery': 'ho dimenticato la password',
        'reference': 'riferimento',
        'refund': 'rimborso',
        'refunded': 'rimborsato',
        'removeImage': 'rimuovere l\'immagine',
        'reports': 'rapporti',
        'reset': 'riavviare',
        'result': 'risultato',
        'results': 'risultati',
        'right': 'diritto',
        'role': 'ruolo',
        'routes': 'itinerari',
        'row': 'fila',
        'ruta': 'itinerari',
        'saleDate': 'da',
        'sales': 'vendite',
        'save': 'salvare',
        'schedules': 'orari',
        'search': 'cercare',
        'secondary': 'secondari',
        'sellBy': 'venduto par',
        'seller': 'venditore',
        'send': 'inviare',
        'senior': 'senior',
        'sequent': 'consecutivo',
        'serial': 'numero di serie',
        'serviceDescription': 'descrizione del servizio ',
        'serviceDuration': 'durata del servizio',
        'serviceDurationTooltip': 'punta dello strumento di durata del servizio',
        'serviceName': 'nome di servizio',
        'serviceWithHourUse': 'servizio con orario di utilizzo',
        'serviceWithVehiculo': 'contrassegnare per il servizio fornito con veicolo',
        'servicio': 'servizio',
        'settingcashmovements': 'movimenti di regolazione di cassa',
        'settings': 'impostazioni',
        'showEntries': 'mostrare ingresso',
        'showing': 'mostrando',
        'si': 'sì',
        'simulator': 'simulatore',
        'sinValidar': 'non riuscita',
        'soldTo': 'venduto a',
        'start': 'inizia',
        'start_at': 'inizia',
        'state': 'stato',
        'status': 'stado',
        'stock': 'stock',
        'stockable': 'stoccaggio',
        'stretch': 'servizo',
        'stretches': 'servizi',
        'stretchesSelected': 'servizi selezionati',
        'stretchValues': 'servizi inclusi',
        'student': 'Studente',
        'supervisor': 'supervisore',
        'tag': 'etichetta',
        'tags': 'etichette',
        'tax': 'tassa',
        'taxAmount': 'importo della tassa',
        'taxBase': 'base imponibile',
        'taxes': 'tassa',
        'telephone': 'telefono',
        'terminal': 'terminale di vendita ',
        'terminalnumero': 'numero di terminali',
        'terminalPhysicalPOS': 'terminal fisico',
        'terminalSale': 'terminale di vendita',
        'terminalVirtual': 'terminale virtuale',
        'termsDataweb': 'termini e condizioni',
        'ticket': 'ticket',
        'tickets': 'tickets',
        'ticketsRefunded': 'biglietti annullati',
        'timeAdvance': 'tempo prima dell\'uso per convalidare il biglietto (in minuti)',
        'timeAfterValidateTicket': 'tempo successivo all\'orario di utilizzo per convalidare il biglietto (in minuti)',
        'timeBeforeValidateTicket': 'tempo prima dell\'orario di utilizzo per convalidare il biglietto (in minuti)',
        'timeCancel': 'tempo massimo per cancellare il biglietto (in minuti)',
        'timeDelay': 'tempo successivo per convalidare il biglietto',
        'timeExpiration': 'valido per',
        'timeExpirationHour': 'minuti di validità per il biglietto a partire dall\'orario di utilizzo',
        'timeFirstValidateTicket': 'tempo per convalidare il biglietto la prima volta dalla data di vendita (in giorni). \' 0\' per il giorno corrente',
        'timeMaxCancelTicket': 'Tempo massimo per annullare il biglietto convalidato dopo averlo emesso. (in minuti)',
        'timeUse': 'tempo di utilizzo',
        'timeUseAfterValidaton': 'Tempo di utilizzo del biglietto a partire dalla convalida (in ore). HopOn HopOff o Ritorno. \'0\' per il resto della giornata (fino alle 23:59)',
        'tin': 'P.IVA-C.Fiscale',
        'tipoPago': 'metodi di pagamento',
        'to': 'fino a',
        'today': 'oggi',
        'total': 'Totale',
        'totalCanceled': 'totale cancellato',
        'totalCard': 'totale carta ',
        'totalCash': 'totale effettivo',
        'totalCheckins': 'totale checkins',
        'totalCredit': 'total de credito',
        'totalCreditCanceled': 'totale del credito cancellato',
        'totalDescuento': 'totale sconto',
        'totalDiscount': 'sconto Totale',
        'totalOther': 'totale altro',
        'totalRefund': 'rimborso totale',
        'totalSales': 'totale vendite',
        'totalTickets': 'totale tickets',
        'totalTranfer': 'trasferimento totale',
        'tradename': 'nome commerciale',
        'tramoHora': 'servizio con orario\n',
        'tramoHorario': 'tratto orario',
        'transf': 'transf.',
        'transfer': 'trasferimento',
        'transfered': 'totale per transferimento',
        'tranvia': 'tram',
        'trenecito': 'trenino',
        'trenParada': 'fermata del treno',
        'tutorialCivitrip': 'tutorial di Civitrip',
        'type': 'tipo',
        'typeMovement': 'tipo di movimento',
        'typePassengers': 'tipo di passeggeri',
        'typeDiscount': 'tipo di sconto',
        'typePrice': 'calcolo del prezzo',
        'typeSale': 'tipo di vendita',
        'typeVehicle': 'tipo di veicolo',
        'unitary': 'servizio che è prenotato completo',
        'unitaryTooltip': 'servizio prenotato per intero indipendentemente dal numero di passeggeri selezionati',
        'units': 'unitàs',
        'unitsTooltip': 'quantità prevista dal servizio. Ad esempio numero di veicoli',
        'unpaid': 'non retribuito',
        'update': 'aggiornare',
        'usedGauges': 'persone all\'interno',
        'user': 'utente',
        'username': 'nome utente',
        'users': 'utenti',
        'validated': 'convalidati',
        'validoHasta': 'Valido fino a',
        'validoPara': 'Valido per',
        'value': 'valore',
        'vehicles': 'veicoli',
        'virtual': 'venditore virtuale',
        'virtualTickets': 'biglietti virtuali',
        'voucher': 'buoni',
        'vouchers': 'buoni',
        'vuelta': 'andata e ritorno',
        'web': 'web',
        'webExpiration': 'tempo per pagare nel carrello web',
        'webExpirationMessage': 'tempo di prenotazione del servizio nel carrello fino al momento del pagamento',
        'webMoney': 'valuta per il web',
        'week': 'settimana',
        'wharehouse': 'magazzino',
        'withoutTax': 'senza tasse',
        'withVehicle': 'con veicolo',
        'year': 'anno',
        'yEl': 'e il',
        'yes': 'si',
        'zip': 'Codice postale',
        'modules': 'moduli',
        'moduleMarketing': 'marketing',
        'civitrip': 'civitrip',
        'checkVersion': 'controlla la versione',
        'privateApiToken': 'token api privato',
        'publicApiToken': 'token api pubblico',
        'noteNotShareToken': 'Nota: Non condividere o rendere pubblico il token api privato',
        'showCredentialsConnectEcommerce': 'Di seguito sono mostrate le credenziali necessarie per collegare Ticando al tuo ecommerce.',
        'descriptionAppModule': 'modulo per la vendita al cliente finale con intervento del personale aziendale tramite dispositivo mobile Android fisico attraverso l\'app',
        'descriptionCollabortorModule': 'modulo che consente la vendita collaborativa di esperienze-servizi di altri fornitori',
        'descriptionEcommerceModule': 'modulo per la vendita al cliente finale senza intervento del personale aziendale',
        'descriptionVirtualModule': 'modulo per la vendita al cliente finale con intervento del personale aziendale tramite dispositivo virtuale',
        'moduleApp': 'app',
        'moduleCollaborator': 'collaboratore',
        'moduleEcommerce': 'e-commerce',
        'moduleVirtual': 'virtuale',
        'byDate': 'per data',
        'byDays': 'per giorni',
        'byMonth': 'per mese',
        'bySaleDate': 'per data di vendita',
        'byUseDate': 'per data di utilizzo',
        'fromRange': 'da',
        'toRange': 'a',
        'dateCheck': 'emesso',
        'dateMaxToReserve': 'data massima per prenotare',
    },
    'fr': {
        '0-introduccion': 'Introduction',
        '10-listadoTickets': 'Liste de tickets',
        '11-crearPaquete': 'Créer un package',
        '12-familiasArticulos': 'Familles d\'article',
        '1-crearnegocio': 'Créer des affaires',
        '1-introduccion': '01. Introduction',
        '2-crearUsuario': 'Créer un utilisateur ',
        '2-negocios': '02. Affaires',
        '3-modificarUsuario': 'Modifier l`utilisateur',
        '3-usuarios': '03. Utilisateur',
        '4-categoriasPasajeroHorarios': '04. Catégorie de passagers, horaires',
        '4-crearCategoriaPasajero': 'Créer une catégorie de passagers ',
        '5-impuestoExtrasMonedas': '05. Taxes, extras, monnaie',
        '5-Linea de operacion': 'Ligne d’opération ',
        '6-lineaOperacion': '06. Ligne d\'opération',
        '6-servicio ida y vuelta': 'Service d\'aller et retour',
        '7-ServicioHopONHopoff': 'Service hopONhopOFF',
        '7-servicios': '07. Services',
        '8-crearHorarios': 'Créer des horaires',
        '9-servicioConHorario': 'Service horaire',
        'acount': 'Ma compte ',
        'actives': 'Actifs',
        'activo': 'Actif',
        'add': 'Ajouter',
        'additional': 'Supplémentaire',
        'additionalInformation': 'Information suplémentaire',
        'additionalNote': 'Note supplémentaire',
        'address': 'Adresse',
        'addRow': 'Ajouter une ligne',
        'addSeats': 'Ajouter des sièges',
        'aditional': 'Information suplémentaire',
        'aditionalInfo': 'Informations supplémentaires sur le service à afficher à la fin du ticket',
        'administrator': 'Gestionnaire',
        'adult': 'Adulte',
        'typePassenger': {
            'adult': 'adulte',
            'child': 'enfant',
            'handicapped': 'handicapé',
            'infant': 'bébé',
            'military': 'militaire',
            'pensioner': 'pensionné',
            'resident': 'résident',
            'senior': 'senior',
            'student': 'étudiant'
        },
        'afiliate': 'Affilié',
        'afiliateName': 'Nom d’affilié',
        'afiliates': 'Affiliés',
        'all': 'Tous',
        'allAfiliates': 'Tous les affiliés',
        'allBusiness': 'Toutes les affaires',
        'allDiscounts': 'Code réduction',
        'allTickets': 'Tous les tickets',
        'alphabeticCode': 'Code alphabétique',
        'alpha_dash_space': 'Le champ :attribute ne doit contenir que des lettres, des chiffres, des tirets et des espaces (espaces non à la fin).',
        'amount_paid': 'Montant payé',
        'amount_paid_boxoffice': 'Montant payé au guichet',
        'aPartirValidacion': 'Depuis la première validation ',
        'appliedCorrectly': 'filets correctement appliqués',
        'appliedError': 'erreur lors de l\'application des filets',
        'applyNet': 'appliquer le net à tous les services partagés',
        'applyCommission': 'la commission sera appliquée, les valeurs actuelles seront écrasées',
        'appName': 'Web back-office',
        'areaconfig': 'Zone de configuration',
        'article': 'Article',
        'articles': 'Articles',
        'articleTickets': 'Billet d\'article',
        'as': 'Comme',
        'askAdditionalInformation': 'demandez toute information complémentaire',
        'atraccion': 'Attraction',
        'autobus': 'Bus',
        'available': 'Disponible',
        'avion': 'Avion',
        'back': 'dos',
        'barco': 'Bateau',
        'barcode': 'Code à barres',
        'beCollaborator': 'Être partenaire',
        'bicicleta': 'Vélo',
        'block': 'Bloqué',
        'bookingFee': 'booking fee',
        'branch': 'Délégation',
        'branches': 'Délégations',
        'brand': 'Marque',
        'buceo': 'Plongée',
        'bus': 'Bus',
        'business': 'Entreprise',
        'businessName': 'Nom fiscal',
        'businessunit': 'Affaire',
        'businessUnit': 'Affaire',
        'businessUnitName': 'Nom d\'affaire',
        'businessunits': 'Affaires',
        'businessUnits': 'Affaires',
        'busParada': 'Arrêt de bus',
        'busTuristico': 'Bus hop-ON hop-OFF',
        'byHours': 'par heures',
        'byGroup': 'Groupe',
        'byPassenger': 'Par passager',
        'calculadora_precios_sin_iva': 'Calculateur de prix sans frais',
        'calendar': 'Calendrier',
        'calendarAvailable': 'Disponibilité sur Calendar',
        'calendarMonth': 'Mois du calendrier',
        'cancel': 'Annuler',
        'canceled': 'anuleé',
        'canceledNoModified': 'billet annulé, non modifiable',
        'canceledTickets': 'Billets annulés',
        'capacity': 'Capacité',
        'card': 'Carte bancaire',
        'cardAmount': 'Montant de la carte',
        'carded': 'Total sur carte',
        'cash': 'Espèce',
        'cashAmount': 'Total effectif',
        'cashDesk': 'Encaisse',
        'cashDeskClosures': 'Fermetures de caisse',
        'cashDeskOpen': 'La boîte est déjà ouverte',
        'cashed': 'encaisse',
        'categoriaPasajero': 'catégorie passager',
        'category': 'catégorie',
        'categories': 'catégories',
        'changeDatebook': 'changer la date d\'utilisation',
        'checkins': 'check-in',
        'city': 'ville',
        'client': 'client',
        'close': 'fermeture',
        'code': 'code',
        'codeDiscount': 'code promo',
        'collaboratorCode': 'code collaborateur',
        'collaboratorEmail': 'email de collaborateur',
        'collaboratorName': 'nom du collaborateur',
        'collaboratorPacket': 'paquet collaborateur',
        'collaboratorpackets': 'paquets collaboratifs',
        'collaborators': 'partenaire',
        'collaboratorService': 'vente aux collaborateurs',
        'collaboratorspackets': 'paquets de collaboration',
        'collaboratorStretch': 'service en collaboration',
        'collaboratorstretches': 'service en collaboration',
        'collaboratorStretchValues': 'valeur du service de collaboration\n',
        'collaboratorTickets': 'vente aux collaborateurs\n',
        'collaboratorTin': 'CIF collaborateur',
        'collaboratortretches': 'services en collaboration',
        'commission': 'commission',
        'concepto': 'concept',
        'confirmDelete': 'confirmer supprimer?',
        'confirmDisable': 'confirmer désactiver?',
        'confirmEnable': 'confirmer activer ?',
        'contactName': 'personne de contact',
        'contactPhone': 'téléphone de contact',
        'copiedToClipboard': 'copié dans le presse-papier',
        'cost': 'coût',
        'create': 'créer',
        'credit': 'crédit',
        'creditCanceled': 'crédit annulé',
        'credited': 'total crédit',
        'currency': 'devise',
        'custom': 'personnalissé',
        'customed': 'personnalisé',
        'customers': 'clients',
        'customized': 'personnalisé',
        'dashboard': 'panneau de contrôle',
        'dashboardticket': 'ticket panneau de contrôle',
        'dataWeb': 'donneés web',
        'date': 'date',
        'datebook': 'date d\'utilisation',
        'dateBook': 'date de réservation',
        'datecheck': 'date d\'émission',
        'dateClose': 'date de clôture',
        'dateOpen': 'date d\'ouverture',
        'daterefund': 'date d\'annulation',
        'dateRefund': 'date d\'annulation',
        'dateSI': 'date de la facture',
        'datevalited': 'date de validation',
        'dateValited': 'date de validation',
        'day': 'jour',
        'delayTime': 'temps de retard',
        'delete': 'supprimer',
        'departureTime': 'heure de départ',
        'description': 'description',
        'desde': 'depuis',
        'destination': 'destination',
        'devices': 'dispositif',
        'disable': 'désactiver',
        'disableAll': 'désactiver tout',
        'disabled': 'désactiver',
        'disabled_at': 'désactivé dans',
        'disableMonth': 'désactivé mois\n',
        'disableTerminal': 'désactiver sur le terminal Android\n',
        'disableTerminalTooltip': 'sélectionnez pour ne pas autoriser la vente sur le terminal android',
        'disableVirtual': 'désactiver dans virtuel',
        'disableVirtualTooltip': 'sélectionnez pour ne pas autoriser la vente virtuelle',
        'disableWeb': 'désactiver sur le web ',
        'disableWebTooltip': 'sélectionnez pour ne pas autoriser la vente sur le web',
        'discount': 'réduction',
        'discountcodes': 'codes de réduction',
        'discountreasons': 'raison discount',
        'discountTickets': 'tickets discount',
        'download': 'télécharger',
        'due': 'terme',
        'edit': 'éditer',
        'email': 'email',
        'emails': 'emails',
        'emailsToSend': 'Emails pour envoyer la notification de réservation',
        'enable': 'permettre',
        'enableAll': 'activer tout',
        'enabled': 'activé',
        'enableMonth': 'activer mois',
        'endHour': 'heure de fin',
        'error_array_emails_comma': 'erreur dans la liste des emails (entrez séparés par des virgules et sans espaces)',
        'excursion': 'excursion',
        'expiredLicense': 'licence expirée',
        'expire': 'prend fin',
        'expire_at': 'prend fin',
        'extras': 'suppléments',
        'families': 'gammes de produits',
        'family': 'famille',
        'fix': 'fixe',
        'following': 'suivant',
        'footer': 'footer',
        'from': 'puis',
        'funcion': 'fonction',
        'funicular': 'funiculaire',
        'generalSales': 'ventes générales',
        'handicapped': 'handicapé',
        'hasta': 'juaqu\'à',
        'headboards': 'en-têtes de ticket',
        'header': 'en-tête',
        'helicopero': 'hélicoptère',
        'help': 'aide',
        'hoponHopoff': 'HopON-HopOFF',
        'hopOnOff': 'hopOnOff',
        'hora': 'heure',
        'horasIda': 'heures de départ',
        'horasVuelta': 'horaires de retour',
        'hours': 'heures',
        'id': 'identification',
        'ida': 'départ',
        'idavuelta': 'aller-retour',
        'idaVuelta': 'aller et retour',
        'image': 'image',
        'imageProperties': 'image au format jpg avec un minimum de 600x600 px',
        'imagesDataweb': 'images',
        'informationWeb': 'informations sur le web',
        'in': 'entrée',
        'infant': 'bébé',
        'info': 'info',
        'infoDataweb': 'description',
        'initHour': 'heure de début',
        'invoice': 'facture',
        'invoiceSimple': 'facture simplifiée',
        'lancha': 'bateau',
        'lastname': 'nom',
        'left': 'gauche',
        'license': 'licence',
        'licenses': 'licences',
        'listMonth': 'liste mois',
        'limitUse': 'limite d\'utilisation',
        'logIn': 'se connecter',
        'error': {
            'loginAgain': 'se reconnecter',
            'tryAgainLater': 'réessayer plus tard',
            'unableConnect': 'impossible de se connecter, vérifier la connexion',
            'userNoAccess': 'Accès interdit pour ce type d’utilisateur'
        },
        'logOut': 'quitter',
        'manufacturer': 'fabricant',
        'margin': 'marge',
        'maxToReserve': 'maximum sur réservation ',
        'military': 'Militaire',
        'minReserver': 'réservation minimum',
        'minToPayWeb': 'pourcentage pour paiement partiel par le web',
        'minToPayWebTooltip': 'pourcentage pour le paiement partiel sur le web. \nSi 0 ou est supprimé, aucun paiement partiel n’est autorisé sur le web',
        'minToReserve': 'minimum pour réservation',
        'minutes': 'minutes',
        'model': 'modèle',
        'modelo': 'modèle',
        'money': 'monaie',
        'moneys': 'devises',
        'month': 'mois',
        'moto': 'moto',
        'motoAgua': 'jet ski',
        'mr_mrs': 'Msr/Mme',
        'museo': 'musée',
        'myAccount': 'ma compte ',
        'name': 'nom',
        'nameServiceIn': 'nom du service',
        'netAmount': 'base imposable',
        'no': 'no',
        'noCopiedClipboard': 'impossible de copier dans le presse-papiers',
        'noDataShow': 'aucune donnée à afficher ',
        'none': 'aucun',
        'notAvailable': 'non disponible',
        'nothingModified': 'aucune modification n’a été apportée',
        'notHourSelected': 'manque sélectionner heures sur un service',
        'number': 'numéro',
        'numericCode': 'code numérique',
        'numero': 'numéro de billet',
        'odd': 'impair',
        'of': 'de',
        'offset': 'séparation',
        'offsetBottom': 'fond décalé ',
        'offsetLeft': 'déviation vers la gauche ',
        'offsetRight': 'séparation à droite ',
        'offsetRow': 'séparation rangée',
        'offsetTop': 'séparation en haut',
        'ok': 'ok',
        'open': 'ouverture',
        'operario': 'opérateur',
        'operationline': 'ligne d’opération',
        'operationLine': 'ligne opérative',
        'operationLineName': 'nom du ligne d\'opération',
        'operationlines': 'lignes d\'opération',
        'operator': 'opérateur',
        'operatorName': 'nom d\'opérateur',
        'operatorTickets': 'billets d’opérateur',
        'origin': 'origine',
        'orphan': 'sans famille',
        'otas': 'otas',
        'other': 'outre',
        'othered': 'autres paiements',
        'out': 'sortie',
        'owner': 'propriétaire',
        'packet': 'paquet',
        'packetName': 'nom du paquet',
        'packets': 'paquets',
        'packetsales': 'vente de paquets',
        'packetticket': 'billet de paquet',
        'packettickets': 'billets de paquet',
        'paid': 'payé',
        'pair': 'paire',
        'panoramica': 'panoramique',
        'parael': 'pour le',
        'paraUsarEntre': 'à utiliser entre',
        'paraUsarHasta': 'pour utiliser jusqu’à',
        'paraValidarEntre': 'pour valider enre',
        'parcialAvailable': 'partiellement disponible',
        'parent': 'père',
        'parqueAtracciones': 'parc d\'attractions',
        'partialClose': 'fermeture partielle',
        'passenger': 'passager',
        'passengercategories': 'catégorie de passager',
        'passengers': 'passagers',
        'password': 'mot de passe',
        'patin': 'patin',
        'payDue': 'effectuer un paiement',
        'paymentCard': 'paiement par carte',
        'paymentCash': 'payé en espèces',
        'paymentCredit': 'payé à crédit',
        'paymentOther': 'payé selon d’autres méthodes ',
        'payments': 'paiements',
        'paymentTransfer': 'paiement par virement',
        'percentage': 'percentage',
        'phone': 'téléphone',
        'physicalPOS': 'terminal physique',
        'policy': 'politique',
        'previous': 'précédent',
        'price': 'prix',
        'prices': 'prix',
        'pricesForAfiliate': 'prix pour les affiliés',
        'pricesForCollaborator': 'prix par collaborateurs',
        'pricesIdaVueltaWithoutTax': 'prix aller-retour (hors taxes)',
        'pricesWithoutTax': 'prix (hors taxes)',
        'priceWithoutTax': 'prix (hors taxes)',
        'priceWithTax': 'prix (taxes comprises)',
        'primary': 'principal',
        'primaryMoney': 'principal devise',
        'print': 'imprimer',
        'printPrice': 'imprimer le prix',
        'printPriceTicket': 'imprimer le prix sur le ticket',
        'propierties': 'propriétés',
        'province': 'province',
        'quantity': 'quantité',
        'rangeDate': 'plage de dates',
        'receiptLayout': 'modèle de quittance',
        'receipt_total': 'total',
        'recovery': 'mot de passe oublié',
        'reference': 'référence',
        'refund': 'remboursemente',
        'refunded': 'remboursé',
        'removeImage': 'supprimer l’image',
        'reports': 'rapports',
        'reset': 'relancer',
        'result': 'résultat',
        'results': 'résultats',
        'right': 'droit',
        'role': 'rôle',
        'routes': 'routes',
        'row': 'ligne',
        'ruta': 'route',
        'saleDate': 'depuis',
        'sales': 'vente',
        'save': 'garder',
        'schedules': 'horaires',
        'search': 'rechercher',
        'secondary': 'secundaire',
        'sellBy': 'vendu par',
        'seller': 'vendeur',
        'send': 'envoyer',
        'senior': 'senior',
        'sequent': 'consécutif',
        'serial': 'numéro de série',
        'serviceDescription': 'description du service',
        'serviceDuration': 'durée du service',
        'serviceDurationTooltip': 'durée du service',
        'serviceName': 'nom du service',
        'serviceWithHourUse': 'service avec heure d’utilisation',
        'serviceWithVehiculo': 'Marque pour service fourni avec véhicule',
        'servicio': 'service',
        'settingcashmovements': 'mouvements de trésorerie',
        'settings': 'réglage',
        'showEntries': 'afficher l\'entrée',
        'showing': 'montrant',
        'si': 'oui',
        'simulator': 'simulateur',
        'sinValidar': 'non validées',
        'soldTo': 'vendu à',
        'start': 'dèparts',
        'start_at': 'dèparts',
        'state': 'état',
        'status': 'état',
        'stock': 'stock',
        'stockable': 'stockage',
        'stretch': 'service',
        'stretches': 'services',
        'stretchesSelected': 'services sélectionnés',
        'stretchValues': 'service inclus',
        'student': 'étudiant',
        'supervisor': 'contrôleur',
        'tag': 'étiquette',
        'tags': 'étiquettes',
        'tax': 'impôt',
        'taxAmount': 'montant d\'impôt',
        'taxBase': 'base d\'imposition',
        'taxes': 'impôts',
        'telephone': 'téléphone',
        'terminal': 'terminal de vente',
        'terminalnumero': 'numéro de terminal',
        'terminalPhysicalPOS': 'terminal physique',
        'terminalSale': 'terminal de vente',
        'terminalVirtual': 'terminal virtuel',
        'termsDataweb': 'termes et conditions',
        'ticket': 'ticket',
        'tickets': 'tickets',
        'ticketsRefunded': 'billets annulés',
        'timeAdvance': 'temps avant utilisation temps pour valider le ticket (en minutes)',
        'timeAfterValidateTicket': 'Temps après l\'heure d\'utilisation pour valider le ticket (en minutes)',
        'timeBeforeValidateTicket': 'temps avant l’heure d’utilisation pour valider le ticket (en minutes)',
        'timeCancel': 'Temps maximum pour annuler le billet (en minutes)',
        'timeDelay': 'temps supplémentaire nécessaire pour valider le ticket',
        'timeExpiration': 'valable pour',
        'timeExpirationHour': 'durée de validité du ticket à partir de l’heure d’utilisation',
        'timeFirstValidateTicket': 'temps pour valider le ticket la première fois à partir de la date de vente (en jours). \' 0\' pour le jour actuel',
        'timeMaxCancelTicket': 'Délai maximal d’annulation du ticket validé après sa délivrance. (en minutes)',
        'timeUse': 'temps d\'utilisation',
        'timeUseAfterValidaton': 'Temps d’utilisation du ticket à partir de la validation (en heures). HopOn HopOff ou Tour. \'0\' pour le reste de la journée (jusqu’à 23:59)',
        'tin': 'numéro de TVA',
        'tipoPago': 'méthode de paiement',
        'to': 'jusqu\'à',
        'today': 'aujourd\'hui',
        'total': 'total',
        'totalCanceled': 'total annulé',
        'totalCard': 'total carte',
        'totalCash': 'total effectif',
        'totalCheckins': 'total checkins',
        'totalCredit': 'total crédit',
        'totalCreditCanceled': 'crédit total annulé',
        'totalDescuento': 'total remise',
        'totalDiscount': 'total remise',
        'totalOther': 'totale outre',
        'totalRefund': 'remboursement total',
        'totalSales': 'ventes totaux',
        'totalTickets': 'tickets totaux',
        'totalTranfer': 'transferts totaux',
        'tradename': 'nom commercial',
        'tramoHora': 'service horaire\n',
        'tramoHorario': 'tranche horaire',
        'transf': 'transf.',
        'transfer': 'virement',
        'transfered': 'total par virement',
        'tranvia': 'tram',
        'trenecito': 'petit train',
        'trenParada': 'station de train',
        'tutorialCivitrip': 'tutoriel Civitrip',
        'type': 'type',
        'typeMovement': 'type de mouvement',
        'typePassengers': 'types de passagers',
        'typeDiscount': 'type de remise',
        'typePrice': 'calcul des prix',
        'typeSale': 'type de vente',
        'typeVehicle': 'type de véhicule',
        'unitary': 'service de réservation complet',
        'unitaryTooltip': 'service de réservation complet quel que soit le nombre de passagers sélectionnés',
        'units': 'unités',
        'unitsTooltip': 'quantité dont dispose le service. Par exemple nombre de véhicules',
        'unpaid': 'impayé',
        'update': 'actualiser',
        'usedGauges': 'personnes à l\'intérieur',
        'user': 'utilisateur',
        'username': 'nom d\'utilisateur',
        'users': 'utilisateurs',
        'validated': 'validés',
        'validoHasta': 'valable jusqu\'à',
        'validoPara': 'valable pour',
        'value': 'valeur',
        'vehicles': 'véhicules',
        'virtual': 'vendeur virtuel',
        'virtualTickets': 'tickets virtuels',
        'voucher': 'coupon',
        'vouchers': 'coupons',
        'vuelta': 'aller-retour',
        'web': 'web',
        'webExpiration': 'temps pour payer dans le panier web',
        'webExpirationMessage': 'temps de réservation du service dans le panier jusqu’au paiement',
        'webMoney': 'monnaie pour le web',
        'week': 'semaine',
        'wharehouse': 'entrepôt',
        'withoutTax': 'hors taxes',
        'withVehicle': 'avec voiture',
        'year': 'année',
        'yEl': 'et il',
        'yes': 'oui',
        'descriptionAppModule': 'module pour la vente au client final avec intervention du personnel de l\'entreprise via un appareil mobile Android physique à travers l\'app',
        'descriptionCollabortorModule': 'module qui permet la vente collaborative d\'expériences-services d\'autres fournisseurs',
        'descriptionEcommerceModule': 'module pour la vente au client final sans intervention du personnel de l\'entreprise',
        'descriptionVirtualModule': 'module pour la vente au client final avec intervention du personnel de l\'entreprise via un appareil virtuel',
        'moduleApp': 'app',
        'moduleCollaborator': 'collaborateur',
        'moduleEcommerce': 'e-commerce',
        'moduleVirtual': 'virtuel',
        'zip': 'code postal',
        'modules': 'modules',
        'moduleMarketing': 'marketing',
        'civitrip': 'civitrip',
        'checkVersion': 'vérifier la version',
        'apiToken': 'jeton api privé',
        'privateApiToken': 'jeton api privé',
        'publicApiToken': 'jeton api public',
        'noteNotShareToken': 'Note: Ne partagez pas ou ne rendez pas public le jeton api privé',
        'showCredentialsConnectEcommerce': 'Voici les identifiants nécessaires pour connecter Ticando à votre ecommerce.',
        'byDate': 'par date',
        'byDays': 'par jours',
        'byMonth': 'par mois',
        'bySaleDate': 'par date de vente',
        'byUseDate': 'par date d\'utilisation',
        'fromRange': 'depuis',
        'toRange': 'jusqu\'à',
        'dateCheck': 'émis',
        'dateMaxToReserve': 'date maximum pour réserver',
    },
    'pt': {
        '0-introduccion': 'Introdução',
        '10-listadoTickets': 'lista de bilhetes',
        '11-crearPaquete': 'Criar pacote',
        '12-familiasArticulos': 'Famílias de bens ',
        '1-crearnegocio': 'Criar negócio',
        '1-introduccion': '01. Introdução',
        '2-crearUsuario': 'Criar usuário',
        '2-negocios': '02. Negócio',
        '3-modificarUsuario': 'Modificar usuário',
        '3-usuarios': '03. Usuário',
        '4-categoriasPasajeroHorarios': '04. Categoria passageiro, horários',
        '4-crearCategoriaPasajero': 'Criar categoria de passageiro ',
        '5-impuestoExtrasMonedas': '05. Impostos, extras, moedas',
        '5-Linea de operacion': 'Linha de operação ',
        '6-lineaOperacion': '06. Linha de operação',
        '6-servicio ida y vuelta': 'Serviço de ida e volta',
        '7-ServicioHopONHopoff': 'Serviço hopONhopOFF',
        '7-servicios': '07. Servizi',
        '8-crearHorarios': 'Criar agendas',
        '9-servicioConHorario': 'Serviço com horário',
        'acount': 'Minha conta',
        'actives': 'Activos',
        'activo': 'Ativo',
        'add': 'Acrescentar',
        'additional': 'Adicional',
        'additionalInformation': 'Informação adicional',
        'additionalNote': 'Observação adicional',
        'address': 'Direção',
        'addRow': 'Adicionar linha',
        'addSeats': 'Adicionar lugares',
        'aditional': 'Informação adicional',
        'aditionalInfo': 'Informação adicional do serviço que sairá ao final do ticket',
        'administrator': 'Gestionador',
        'adult': 'Adulto',
        'typePassenger': {
            'adult': 'adulto',
            'child': 'criança',
            'handicapped': 'incapacitado',
            'infant': 'bebê',
            'military': 'militar',
            'pensioner': 'pensionista',
            'resident': 'residente',
            'senior': 'sênior',
            'student': 'estudante'
        },
        'afiliate': 'Afiliado',
        'afiliateName': 'Nome de afiliado',
        'afiliates': 'Afiliados',
        'all': 'Tudos',
        'allAfiliates': 'Tudos os afiliados',
        'allBusiness': 'Todos os negócios',
        'allDiscounts': 'Código descontos',
        'allTickets': 'Todos os tickets',
        'alphabeticCode': 'código alfabético',
        'alpha_dash_space': 'O campo :attribute deve conter apenas letras, números, traços e espaços (espaços não no final).',
        'amount_paid': 'Valor pago',
        'amount_paid_boxoffice': 'Montante pago em bilheteria',
        'aPartirValidacion': 'Após a primeira validação ',
        'appliedCorrectly': 'redes aplicadas corretamente',
        'appliedError': 'erro ao aplicar redes',
        'applyNet': 'aplicar rede a todos os serviços partilhados',
        'applyCommission': 'a comissão será aplicada, os valores atuais serão sobrescritos',
        'appName': 'Back office web',
        'areaconfig': 'Área de configuração',
        'article': 'Artigo',
        'articles': 'Artigos',
        'articleTickets': 'Bilhete de artigo',
        'as': 'Como',
        'askAdditionalInformation': 'solicite qualquer informação adicional',
        'atraccion': 'Atração',
        'autobus': 'Bus',
        'available': 'Disponível',
        'avion': 'Avião',
        'back': 'voltar',
        'barco': 'Barco',
        'barcode': 'Código de barras',
        'beCollaborator': 'Ser colaborador',
        'bicicleta': 'Bicicleta',
        'block': 'Bloqueado',
        'bookingFee': 'booking fee',
        'branch': 'Delegação',
        'branches': 'Delegações',
        'brand': 'Marca',
        'buceo': 'Mergulho',
        'bus': 'Bus',
        'business': 'negócio',
        'businessName': 'Nome fiscal',
        'businessunit': 'Negócio',
        'businessUnit': 'Negócio',
        'businessUnitName': 'Nome de negócio',
        'businessunits': 'Negócios',
        'businessUnits': 'Negócios',
        'busParada': 'Paragem do autocarro',
        'busTuristico': 'Bus hop-ON hop-OFF',
        'byHours': 'por horas',
        'byGroup': 'Grupo',
        'byPassenger': 'Por passageiro',
        'calculadora_precios_sin_iva': 'Calculadora de preços sem taxas',
        'calendar': 'Calendário',
        'calendarAvailable': 'Disponibilidade em tempo útil',
        'calendarMonth': 'Mês do calendário',
        'cancel': 'Cancelar',
        'canceled': 'Cancelado',
        'canceledNoModified': 'bilhete cancelado, não pode ser midificado',
        'canceledTickets': 'Bilhetes cancelados',
        'capacity': 'Capacidade',
        'card': 'Cartão de crédito',
        'cardAmount': 'Valor do cartão',
        'carded': 'Total em cartão',
        'cash': 'Dinheiro',
        'cashAmount': 'Total effetivo',
        'cashDesk': 'Caixa de pagamento em dinheiro',
        'cashDeskClosures': 'Fechos de caixas',
        'cashDeskOpen': 'A caixa já está aberta',
        'cashed': 'total em dinheiro',
        'categoriaPasajero': 'categoria de passageiro',
        'category': 'categoria',
        'categories': 'categorias',
        'changeDatebook': 'alterar data de utilização',
        'checkins': 'checkins',
        'city': 'cidade',
        'client': 'cliente',
        'close': 'encerramento',
        'code': 'código',
        'codeDiscount': 'código de desconto',
        'collaboratorCode': 'código de colaborador',
        'collaboratorEmail': 'email de colaborador',
        'collaboratorName': 'nome do colaborador',
        'collaboratorPacket': 'pacote de colaboradores',
        'collaboratorpackets': 'pacotes em colaboração',
        'collaborators': 'colaborador',
        'collaboratorService': 'venda a colaboradores',
        'collaboratorspackets': 'pacotes de colaboração',
        'collaboratorStretch': 'serviço de colaboração',
        'collaboratorstretches': 'serviço de colaboração',
        'collaboratorStretchValues': 'valor do serviço em colaboração',
        'collaboratorTickets': 'venda a colaboradores\n',
        'collaboratorTin': 'NIF colaborador',
        'collaboratortretches': 'serviços de colaboração',
        'commission': 'comissão',
        'concepto': 'conceito',
        'confirmDelete': 'confirmar eliminar?',
        'confirmDisable': 'confirmar desabilitar?',
        'confirmEnable': 'confirmar habilitar?',
        'contactName': 'pessoa de contato',
        'contactPhone': 'telefone de contato',
        'copiedToClipboard': 'copiado para a área de transferência',
        'cost': 'custo',
        'create': 'criar',
        'credit': 'credito',
        'creditCanceled': 'crédito cancelado',
        'credited': 'total de crédito',
        'currency': 'moeda',
        'custom': 'personalizado',
        'customed': 'personalizado',
        'customers': 'clientes',
        'customized': 'personalizado',
        'dashboard': 'painel de controle',
        'dashboardticket': 'ticket painel de controle',
        'dataWeb': 'dados da web',
        'date': 'data',
        'datebook': 'data de utilização',
        'dateBook': 'data da reserva',
        'datecheck': 'data de emissão',
        'dateClose': 'data de encerramento',
        'dateOpen': 'data de abertura',
        'daterefund': 'data de cancelamento',
        'dateRefund': 'data de cancelamento',
        'dateSI': 'data da fatura',
        'datevalited': 'data de validação',
        'dateValited': 'data de validação',
        'day': 'dia',
        'delayTime': 'tempo de retardo',
        'delete': 'excluir',
        'departureTime': 'hora de partida',
        'description': 'descrição',
        'desde': 'desde',
        'destination': 'destino',
        'devices': 'dispositivo',
        'disable': 'disativar',
        'disableAll': 'desactivar todos',
        'disabled': 'desativar',
        'disabled_at': 'desabilitado em',
        'disableMonth': 'desativado mês\n',
        'disableTerminal': 'desabilitar em terminal Android\n',
        'disableTerminalTooltip': 'selecione para não permitir a venda no terminal android',
        'disableVirtual': 'desabilitar',
        'disableVirtualTooltip': 'selecione para não permitir a venda virtual',
        'disableWeb': 'desbilitar',
        'disableWebTooltip': 'selecione para não permitir a venda na web',
        'discount': 'desconto',
        'discountcodes': 'códigos de desconto',
        'discountreasons': 'razão desconto',
        'discountTickets': 'bilhetes com desconto',
        'download': 'descarregar',
        'due': 'prazo',
        'edit': 'editar',
        'email': 'email',
        'emails': 'emails',
        'emailsToSend': 'email para notificação de reserva',
        'enable': 'ativare',
        'enableAll': 'ativar tudo',
        'enabled': 'ativado',
        'enableMonth': 'habilitar mês',
        'endHour': 'hora de término',
        'error_array_emails_comma': 'erro na lista de emails (digite separado por vírgulas e sem espaços em branco)',
        'excursion': 'excursão',
        'expiredLicense': 'licença caducada',
        'expire': 'termina',
        'expire_at': 'termina',
        'extras': 'adicionais',
        'families': 'supplémentaires',
        'family': 'famílias',
        'fix': 'fixo',
        'following': 'seguinte',
        'footer': 'footer',
        'from': 'de',
        'funcion': 'função',
        'funicular': 'funicular',
        'generalSales': 'vendas globais',
        'handicapped': 'incapacitado',
        'hasta': 'até',
        'headboards': 'cabeçalhos do ticket',
        'header': 'cabeceira',
        'helicopero': 'helicóptero',
        'help': 'ajuda',
        'hoponHopoff': 'HopON-HopOFF',
        'hopOnOff': 'hopOnOff',
        'hora': 'hora',
        'horasIda': 'horários de partida',
        'horasVuelta': 'horários de regresso',
        'hours': 'horários',
        'id': 'identificação',
        'ida': 'ida',
        'idavuelta': 'ida e volta',
        'idaVuelta': 'ida e volta',
        'image': 'imagem',
        'imageProperties': 'Imagem em formato jpg com um mínimo de 600x600 px',
        'imagesDataweb': 'imagens',
        'informationWeb': 'informações da web',
        'in': 'entrada',
        'infant': 'bebê',
        'info': 'info',
        'infoDataweb': 'descrição',
        'initHour': 'hora de início',
        'invoice': 'fatura',
        'invoiceSimple': 'factura simplificada',
        'lancha': 'barco',
        'lastname': 'sobrenome',
        'left': 'esquerda',
        'license': 'licença',
        'licenses': 'licenças',
        'listMonth': 'lista mês',
        'limitUse': 'limite de uso',
        'logIn': 'iniciar sessão',
        'error': {
            'loginAgain': 'Iniciar sessão de novo',
            'tryAgainLater': 'tentar novamente mais tarde',
            'unableConnect': 'Impossível conectar, verificar conexão',
            'userNoAccess': 'acesso proibido para este tipo de usuário'
        },
        'logOut': 'sair',
        'manufacturer': 'fabricante',
        'margin': 'margem',
        'maxToReserve': 'máximo na reserva ',
        'military': 'Militar',
        'minReserver': 'reserva mínima',
        'minToPayWeb': 'Percentagem de pagamento parcial na web',
        'minToPayWebTooltip': 'percentagem de pagamento parcial na Internet. \nSe é 0 ou é excluído não é permitido pagamento parcial na web',
        'minToReserve': 'mínimo para reserva',
        'minutes': 'minutos',
        'model': 'modelo',
        'modelo': 'modelo  ',
        'money': 'moeda',
        'moneys': 'moedas',
        'month': 'mês',
        'moto': 'moto',
        'motoAgua': 'jet ski',
        'mr_mrs': 'Sir/Madam',
        'museo': 'museu',
        'myAccount': 'minha conta',
        'name': 'nome',
        'nameServiceIn': 'nome do serviço',
        'netAmount': 'valor tributável',
        'no': 'no',
        'noCopiedClipboard': 'não foi possível copiar para a área de transferência',
        'noDataShow': 'não há dados para mostrar ',
        'none': 'nenhum',
        'notAvailable': 'não disponível',
        'nothingModified': 'não foram introduzidas alterações',
        'notHourSelected': 'falta selecionar horas em algum serviço',
        'number': 'número',
        'numericCode': 'código numérico',
        'numero': 'número do ticket',
        'odd': 'ímpar',
        'of': 'de',
        'offset': 'separação',
        'offsetBottom': 'fundo deslocado ',
        'offsetLeft': 'desvio para a esquerda',
        'offsetRight': 'separação à direita ',
        'offsetRow': 'linha de separação',
        'offsetTop': 'separação acima',
        'ok': 'ok',
        'open': 'abertura',
        'operario': 'operador',
        'operationline': 'linha de operação',
        'operationLine': 'linha de operação ',
        'operationLineName': 'nome da linha de operação',
        'operationlines': 'linha de operação',
        'operator': 'operador',
        'operatorName': 'nome do operador',
        'operatorTickets': 'bilhetes de operador',
        'origin': 'origem',
        'orphan': 'sem família',
        'otas': 'otas',
        'other': 'otro',
        'othered': 'outros pagamentos',
        'out': 'sortida',
        'owner': 'propiétario',
        'packet': 'pacote',
        'packetName': 'nome do pacote',
        'packets': 'pacotes',
        'packetsales': 'venda de pacotes',
        'packetticket': 'bilhetes de pacote ',
        'packettickets': 'bilhetes do pacote',
        'paid': 'pago',
        'pair': 'par',
        'panoramica': 'panorâmica',
        'parael': 'para a',
        'paraUsarEntre': 'para uso entre',
        'paraUsarHasta': 'para usar até',
        'paraValidarEntre': 'para validar entre',
        'parcialAvailable': 'parcialmente disponível',
        'parent': 'pae',
        'parqueAtracciones': 'parque de diversões',
        'partialClose': 'encerramento parcial',
        'passenger': 'passagero',
        'passengercategories': 'categoria passaggeiro',
        'passengers': 'passageiros',
        'password': 'palavra-passe',
        'patin': 'patim',
        'payDue': 'completar pagamento',
        'paymentCard': 'pagamento com cartão',
        'paymentCash': 'pago em dinheiro',
        'paymentCredit': 'pago em crédito',
        'paymentOther': 'pagos por outros métodos ',
        'payments': 'pagamentos',
        'paymentTransfer': 'pagamento em transferência',
        'percentage': 'porcentagem',
        'phone': 'telefone',
        'physicalPOS': 'terminal físico',
        'policy': 'politica',
        'previous': 'anterior',
        'price': 'preço',
        'prices': 'preços',
        'pricesForAfiliate': 'preço para afiliados',
        'pricesForCollaborator': 'preço para colaboradores',
        'pricesIdaVueltaWithoutTax': 'preços de ida e volta (sem impostos)',
        'pricesWithoutTax': 'preços (sem impostos)',
        'priceWithoutTax': 'preços (sem impostos)',
        'priceWithTax': 'preços (com impostos)',
        'primary': 'principal',
        'primaryMoney': 'moeda principal',
        'print': 'imprimir',
        'printPrice': 'imprimir preço',
        'printPriceTicket': 'imprimir preço no ticket',
        'propierties': 'propiedades',
        'province': 'província',
        'quantity': 'quantidade',
        'rangeDate': 'intervalo de data',
        'receiptLayout': 'modelo de recibo',
        'receipt_total': 'total',
        'recovery': 'esqueci minha senha',
        'reference': 'referência',
        'refund': 'reembolso',
        'refunded': 'reembolsado',
        'removeImage': 'remover imagem',
        'reports': 'relatórios',
        'reset': 'reiniciar',
        'result': 'resultado',
        'results': 'resultados',
        'right': 'dereito',
        'role': 'funçao',
        'routes': 'itinerário',
        'row': 'linha',
        'ruta': 'itinerário',
        'saleDate': 'desde',
        'sales': 'vendas',
        'save': 'salvar',
        'schedules': 'horários',
        'search': 'procurar',
        'secondary': 'secundario',
        'sellBy': 'vendido por',
        'seller': 'vendedor',
        'send': 'mandar',
        'senior': 'sênior',
        'sequent': 'consecutivo',
        'serial': 'numéro de série',
        'serviceDescription': 'descrição do serviço',
        'serviceDuration': 'tempo de serviço',
        'serviceDurationTooltip': 'dica de ferramenta de duração de serviço',
        'serviceName': 'nome do serviço',
        'serviceWithHourUse': 'serviço com hora de uso',
        'serviceWithVehiculo': 'marcação para serviço prestado com veículo',
        'servicio': 'serviço',
        'settingcashmovements': 'movimentos de ajuste de caixa',
        'settings': 'configuração',
        'showEntries': 'mostrar entrada',
        'showing': 'mostrando',
        'si': 'si',
        'simulator': 'simulador',
        'sinValidar': 'não validados',
        'soldTo': 'vendido a',
        'start': 'começa',
        'start_at': 'começa',
        'state': 'estado',
        'status': 'estado',
        'stock': 'stock',
        'stockable': 'almazenamento',
        'stretch': 'serviço',
        'stretches': 'serviços',
        'stretchesSelected': 'serviços selecionados',
        'stretchValues': 'serviços incluídos',
        'student': 'estudante',
        'supervisor': 'supervisor',
        'tag': 'rótulo',
        'tags': 'rótulos',
        'tax': 'taxa',
        'taxAmount': 'valor do imposto',
        'taxBase': 'base tributária',
        'taxes': 'taxa',
        'telephone': 'telefone',
        'terminal': 'terminal de venda',
        'terminalnumero': 'número do terminal',
        'terminalPhysicalPOS': 'terminal físico',
        'terminalSale': 'terminal de venda',
        'terminalVirtual': 'terminal virtual',
        'termsDataweb': 'termos e condições',
        'ticket': 'ticket',
        'tickets': 'tickets',
        'ticketsRefunded': 'bilhetes cancelados',
        'timeAdvance': 'tempo antes do tempo de uso para validar o bilhete (em minutos)',
        'timeAfterValidateTicket': 'tempo posterior à hora de uso para validar ticket (em minutos)',
        'timeBeforeValidateTicket': 'tempo anterior à hora de uso para validar ticket (em minutos)',
        'timeCancel': 'tempo máximo para cancelar o bilhete (em minutos)',
        'timeDelay': 'tempo posterior para validar ticket',
        'timeExpiration': 'válido por',
        'timeExpirationHour': 'minutos de validade para o ticket a partir da hora de uso',
        'timeFirstValidateTicket': 'tempo para validar o bilhete a primeira vez a partir da data de venda (em dias). \'0\' para o dia atual',
        'timeMaxCancelTicket': 'Tempo máximo para cancelar ticket validado após ter sido emitido. (em minutos)',
        'timeUse': 'tempo de uso',
        'timeUseAfterValidaton': 'Tempo que se poderá usar o ticket a partir da validação (em horas). HopOn HopOff ou Volta. \'0\' para o resto do dia (até as 23:59)',
        'tin': 'FIPV',
        'tipoPago': 'método de pagamento',
        'to': 'até',
        'today': 'hoje',
        'total': 'total',
        'totalCanceled': 'total cancelado',
        'totalCard': 'cartão total',
        'totalCash': 'total efectivo',
        'totalCheckins': 'total checkins',
        'totalCredit': 'total de crédito',
        'totalCreditCanceled': 'crédito total cancelado',
        'totalDescuento': 'desconto total',
        'totalDiscount': 'desconto total',
        'totalOther': 'total outro',
        'totalRefund': 'reembolso total',
        'totalSales': 'total ventas',
        'totalTickets': 'total de bilhetes',
        'totalTranfer': 'transferência total',
        'tradename': 'nome comercial',
        'tramoHora': 'serviço com horário',
        'tramoHorario': 'horário',
        'transf': 'transf.',
        'transfer': 'transferência',
        'transfered': 'total por transferência',
        'tranvia': 'tranvia',
        'trenecito': 'trenzinho',
        'trenParada': 'parada de trem',
        'tutorialCivitrip': 'tutorial Civitrip',
        'type': 'tipo',
        'typeMovement': 'tipo de movimento',
        'typePassengers': 'tipo de passageiros',
        'typeDiscount': 'tipo de desconto',
        'typePrice': 'cálculo de preço',
        'typeSale': 'tipo de venda',
        'typeVehicle': 'tipo de veículo',
        'unitary': 'serviço que se reserva completo',
        'unitaryTooltip': 'serviço que é totalmente reservado, independentemente do número de passageiros selecionados',
        'units': 'unidades',
        'unitsTooltip': 'quantidade disponível para o serviço. Por exemplo, número de veículos',
        'unpaid': 'não remunerado',
        'update': 'actualizar',
        'usedGauges': 'pessoas dentro',
        'user': 'usário',
        'username': 'nome de usuário',
        'users': 'usuários',
        'validated': 'válidos',
        'validoHasta': 'válido até',
        'validoPara': 'válido para',
        'value': 'valor',
        'vehicles': 'veículos',
        'virtual': 'vendedor virtual',
        'virtualTickets': 'tickets virtuais',
        'voucher': 'vales',
        'vouchers': 'vales',
        'vuelta': 'ida e volta',
        'web': 'web',
        'webExpiration': 'tempo para pagar no carrinho web',
        'webExpirationMessage': 'tempo reservado serviço no carrinho até que o pagamento ocorre',
        'webMoney': 'moeda para a web',
        'week': 'semana',
        'wharehouse': 'armazém',
        'withoutTax': 'sem taxas',
        'withVehicle': 'com veículo',
        'year': 'ano',
        'yEl': 'y el',
        'yes': 'si',
        'zip': 'CEP',
        'modules': 'módulos',
        'moduleMarketing': 'marketing',
        'civitrip': 'civitrip',
        'checkVersion': 'verificar a versão',
        'apiToken': 'token api privado',
        'privateApiToken': 'token api privado',
        'publicApiToken': 'token api público',
        'noteNotShareToken': 'Nota: Não compartilhe ou torne público o token api privado',
        'showCredentialsConnectEcommerce': 'Abaixo estão as credenciais necessárias para conectar Ticando ao seu ecommerce.',
        'descriptionAppModule': 'módulo para venda ao cliente final com intervenção do pessoal da empresa através de dispositivo móvel Android físico via app',
        'descriptionCollabortorModule': 'módulo que permite a venda colaborativa de experiências-serviços de outros fornecedores',
        'descriptionEcommerceModule': 'módulo para venda ao cliente final sem intervenção do pessoal da empresa',
        'descriptionVirtualModule': 'módulo para venda ao cliente final com intervenção do pessoal da empresa através de dispositivo virtual',
        'moduleApp': 'app',
        'moduleCollaborator': 'colaborador',
        'moduleEcommerce': 'e-commerce',
        'moduleVirtual': 'virtual',
        'byDate': 'por data',
        'byDays': 'por dias',
        'byMonth': 'por mês',
        'bySaleDate': 'por data de venda',
        'byUseDate': 'por data de uso',
        'fromRange': 'desde',
        'toRange': 'até',
        'dateCheck': 'emitido',
        'dateMaxToReserve': 'data máxima para reservar',
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/languages.ts
// module id = 685
// module chunks = 0